import { Component, OnInit, Input, Output, EventEmitter, ViewChild,Pipe,PipeTransform } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { ApiService } from '../../../services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { ThreadPostService } from '../../../services/thread-post/thread-post.service';
import { Constant,DefaultNewImages,ContentTypeValues,RedirectionPage,pageTitle,IsOpenNewTab,PlatFormType,forumPageAccess } from '../../../common/constant/constant';
import * as moment from 'moment';
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgbModal, NgbModalConfig, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FollowersFollowingComponent } from '../../../components/common/followers-following/followers-following.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from "rxjs";
import { BaseService } from 'src/app/modules/base/base.service';
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import { AddLinkComponent } from '../../../components/common/add-link/add-link.component';
import { SuccessModalComponent } from '../../../components/common/success-modal/success-modal.component';
import { Router } from '@angular/router';
import { ProductMatrixService } from '../../../services/product-matrix/product-matrix.service';
import { ViewRoDetailComponent } from '../../../components/common/view-ro-detail/view-ro-detail.component';
import { RepairOrderManageComponent } from 'src/app/components/common/repair-order-manage/repair-order-manage.component';
import { PlatformLocation } from '@angular/common';
@Pipe({
  name: 'highlight'
})
export class HighlightSearchThreaddetail implements PipeTransform {
  transform(text: string, search: string): string {
    if (search && text) {
      let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern.split(' ').filter((t) => {
        return t.length > 0;
      }).join('|');
      const regex = new RegExp(pattern, 'gi');
      //if(text && text.length){
        //return text[0].replace(regex, (match) => `<mark>${match}</mark>`);
      //}else{
        return text.replace(regex, (match) => `<mark>${match}</mark>`);
      //}
      
    } else {
      return text;
    }
  }
}
@Component({
  selector: 'app-thread-detail-view',
  templateUrl: './thread-detail-view.component.html',
  styleUrls: ['./thread-detail-view.component.scss']
})
export class ThreadDetailViewComponent implements OnInit {

  //@Input() threadViewData;
  @Input() detailView: string = "view-v2";
  @Input() innerHeight: any = 0;
  @Input() public resServices;
  @Output() activePosition: EventEmitter<any> = new EventEmitter();
  @Output() sharedFixCheck: EventEmitter<any> = new EventEmitter();
  @Output() threadTranslateActionEmit: EventEmitter<any> = new EventEmitter();
  @Output() detailViewComponentRef: EventEmitter<ThreadDetailViewComponent> = new EventEmitter();
  @Output() detailViewCallBack: EventEmitter<ThreadDetailViewComponent> = new EventEmitter();
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @ViewChild('ttescalationInfo') estooltip : NgbTooltip;
  subscription: Subscription = new Subscription();
  public sconfig: PerfectScrollbarConfigInterface = {};
  public toHighlight:any='=';
  //public toHighlight: string;
  public toSummayHighlight='Issues: Resolutions:';
  public threadViewData: any = [];
  public loading:boolean = true;
  public searchLoading: boolean = false;
  public userRole:string = '';
  public threadPosted:string = '';
  public theadTitle:string= '';
  public year:string= '';
  public trim1:string= '';
  public trim2:string= '';
  public trim3:string= '';
  public trim4:string= '';
  public trim5:string= '';
  public trim6:string= '';
  public trim:string='';
  public roBusinessInfoJsonArr:any= [];
  public roBusinessContactInfo: any = [];
  public serialNo:string='';
  public scanVersion:string='';
  public WorkOrder:string='';
  public repairOrder:string='';
  public repairOrderLink:string='';
  public estimateLink:string='';
  public inspectionLink:string='';
  public invoiceLink:string='';
  public dviPdfUrlLink:string='';
  public copiedModalPublic: boolean = false;
  public scanVinInfo: any = '';
  public tvsSystem:string='';
  public threadCreatedOn;
  public problemCont:string='';
  public curentDtclength;
  public curentDtcData;
  public currentDtcList: any = [];
  public taglength;
  public tagData;
  public partslength=0;
  public partsData=[];
  public categoryData;
  public categoryLength;
  public subCategoryData;
  public subCategoryLength;
  public productTypeData;
  public productTypeLength;
  public regionsData
  public regionsLength;
  public miles;
  public odometer;
  public occrance;
  public timeApproxtoFixStr: any = "0";
  public milesOdometer;
  public threadEdited;
  public attachmentLoading: boolean = true;
  public action = "view";
  public attachments: any;
  public opendaysCount;
  public opendaysFlag: boolean = false;
  public closeStatus;
  public userRoleTitle:string='';
  public countryId;
  public user:any;
  public domainId;
  public userId;
  public roleId;
  public threadId;
  public postId;
  public shopApiCall;
  public pinCountVal;
  public likeCountVal;
  public plusOneCountVal;
  public pinCount: number = 0;
  public likeCount: number = 0;
  public plusOneCount: number = 0;
  public pinImg;
  public likeImg;
  public plusOneImg;
  public pinLoading: boolean = false;
  public likeLoading: boolean = false;
  public plusOneLoading: boolean = false;
  public pinStatus: number = 0;
  public likeStatus: number = 0;
  public plusOneStatus: number = 0;
  public threadOwner: boolean =false;
  public threadUserId;
  public bodyElem;
  public industryType: any = [];
  public automobileFlag: boolean = false;
  public automobileDefaultImg: boolean = false;
  public techSubmmitFlag: boolean = false;
  public fixesView: boolean = false; 
  public fixesFilter: boolean = false;
  public expiredSubscription: boolean = false;
  public subscriptionInfo: any = [];
  public subscribedProduct: any = [];
  public renewArr = ['incomplete_expired','expired'];
  public cancelArr = ['canceled'];
  public escalateStatusLand='';
  public escalationAction='';
  public nextEscalation='';
  public nextEscalationText='';
  public missingEscalationValue='';
  public errDtcText: string = "";
  public errorDtcIcon: string = "assets/images/common/engine-gray-split-icon.png";
  public currentEscalation='';
  public currentEscalationText='';
  public nextNewEscalation='';
  public nextNewEscalationText='';
  public escColorCodes='';
  public escColorCodesValue='';
  public technicianId: string = '';
  public trimborder: boolean = false;
  public collabticDomain: boolean = false;
  public autoMobile: boolean = false;
  public autoShopAnswersDomain: boolean = false;
  public tvsDomain: boolean = false;
  public tvsIBDomain: boolean = false;
  public tvsIndiaDomain: boolean = false;
  public productCoordinator: any = [];
  public territoryManager: any = [];
  public technicianInfo: any = [];
  public modelAttributes: any = [];
  public additionalInfo: any = [];
  public kaizenCategory: string = '';
  public locationVal: string = '';
  public ipAddr: string = '';
  public severityLevel: string = '';
  public userLoginMethod: string = '';
  public userAffectedDomain: string = '';
  public userEmailAddr: string = '';
  public ricohFlag: boolean = false;
  public msTeamAccess: boolean = false;
  public msTeamAccessMobile: boolean = false;
  public teamSystem = localStorage.getItem("teamSystem");
  public CBADomain: boolean = false;
  public assetPath: string = "assets/images";
  public mediaPath: string = `${this.assetPath}/media`;
  public audioThumb: string = `${this.mediaPath}/audio-medium.png`;
  public audioDesc: any = [];
  public displayDetail: boolean = false;
  public loadServiceFlag: boolean = false;
  public shareFixHours: string = "";
  public threadCatgFlag: boolean = true;
  public scanToolFlag: boolean = false;
  public escalationDescription: string = "";
  public escalationDescriptionUpdate: string = "";
  public viewVersion2: boolean = false;
  public threadCategoryStr: number = 0;
  public KIADomain: boolean = false;
  public diagNationDomain: boolean = false;
  public collabticAutoDomain: boolean = false;
  public collabticFixesDomain: boolean = false;
  public collabticFixesSummaryFlag: boolean = false;
  public resolutionDefaultFlag: boolean = true;
  public llmSummary: any = '';
  public llmSummaryLoading: boolean = true;
  public partsDataStrArrFlag: boolean = false;
  public moreInfo: boolean = false;
  public vinDetails: any = [];
  public likeModal: boolean = false;
  public pinModal: boolean = false;
  public copiedModal: boolean = false;
  public likeActionText: string = "";
  public pinActionText: string = "";
  public isForUser: boolean = false;
  public forPostUser: string = "";
  public threadPostedByCustomerStr:string="";
  public threadPostedByCustomerInt:string="";

  public dialogPosition: string = 'center';
  public reportEmptyBanner = DefaultNewImages.StandardReports;
  public emptyBanner = "assets/images/no-result-media.png";
  public emptyText = "Nothing to show";
  public recallItems: any = [];
  public recallHeight: any = 50;
  public recallFlag: boolean = false;
  public recallLoader: boolean = false;
  public recallEmpty: boolean = true;
  public recallItemEmpty: boolean = false;
  public roLinkFlag: boolean = false;
  public vinEmpty: boolean = true;
  public roModule: boolean = false;
  public endUser: boolean = false;  
  public customerLogin: boolean = false;
  public customerPriority: boolean = false;
  public oldDtcFlag: boolean = false;
  public title: string = "";
  public shortTitle: string = "";
  public contentType: any = ContentTypeValues.RepairOrder;
  public threadViewDataEscation:any = [];
  public reasonFeedbackHistory: boolean = false;
  public reasonFeedbackHistoryLoading: boolean = false;
  public reasonFeedbackHistoryArr: any = [];
  public manageTitle: string = 'Reason for Delayed Reply';
  public aetoolsDomain: boolean = false;
  public AISummaryFlag: boolean = false;
  public AISummaryShow: boolean = false;
  public AISummaryAction: string = '';
  public AISummary: any = '';
  public AISummaryLoading: boolean = true;
  public newDesign: boolean = false;

  constructor(
    private probingApi: ProductMatrixService,
    private router: Router,
    private commonApi: CommonService, 
    private baseSerivce: BaseService,
    private LandingpagewidgetsAPI: LandingpageService,
    private repairOrderApi: RepairOrderService,
    private threadPostService: ThreadPostService,
    private authenticationService:AuthenticationService,
    public apiUrl: ApiService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private modalConfig: NgbModalConfig,
    private location: PlatformLocation
  ) {
      modalConfig.backdrop = 'static';
      modalConfig.keyboard = false;
      modalConfig.size = 'dialog-centered';
   }

  ngOnInit(): void {
    this.subscriptionInfo = this.apiUrl.subscriptionInfo;
    this.subscribedProduct = this.apiUrl.subscribedProduct;
    this.expiredSubscription = this.apiUrl.expiredSubscription;   
    
    if(this.apiUrl.threadViewPublicPage){
      this.domainId = this.apiUrl.threadViewPublicDomainId;
      this.userId = this.apiUrl.threadViewPublicUserId;
    }
    else{
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.roleId = this.user.roleId;
    this.userId = this.user.Userid;
    }

    this.countryId = localStorage.getItem('countryId');
    this.viewVersion2 = localStorage.getItem('threadView') == '1' ? true : false;
    /* let currUrl = this.router.url.split('/');
    if(currUrl[1] == 'threads' && currUrl[2] == 'view'){
      this.viewVersion2 = false;
    }
    else{
      this.viewVersion2 = true;
    } */
    this.displayDetail = (this.detailView == 'view-v2') ? true :false;
    let industryType:any = localStorage.getItem('industryType');
    let platformId = localStorage.getItem('platformId');

    this.aetoolsDomain = this.domainId == '411' ? true : false;
    if((this.domainId == '52' || this.domainId == '97') && platformId == '2' ){
      this.tvsDomain = true;
    }
    if((this.domainId == '97') && platformId == '2' ){
      this.tvsIBDomain = true;
    }
    if(this.domainId == '338'){
      this.diagNationDomain = true;
      localStorage.removeItem('navFromDianationThread');
    }
    if(this.domainId == '63'){
      this.collabticAutoDomain = true;
    }
    if(this.domainId == '336'){
      this.collabticFixesDomain = true;
    }
    if(this.domainId == '386') {
      this.autoShopAnswersDomain = true;
    }
    if(this.collabticFixesDomain){
     //this.collabticFixesSummaryFlag = (this.userId == '2' || this.userId == '4') ? true : false;
     this.collabticFixesSummaryFlag = true;
     this.roModule = false;
    }

    //RO Module check 
    let roEnabled:any = localStorage.getItem('roEnabled');
    roEnabled = (roEnabled && roEnabled != undefined) ? parseInt(roEnabled) : 0;
    this.roModule = (roEnabled > 0) ? true : false;

    this.endUser = (this.roleId == 4) ? true : false;
    let customerPriority:any = localStorage.getItem('customerPriority');
    customerPriority = (customerPriority) ? parseInt(customerPriority) : 0;
    this.customerPriority = (customerPriority > 0) ? true : false;     
    
    this.tvsIndiaDomain = (this.domainId == '52' && platformId == '2' ) ? true : false;
    this.CBADomain = (platformId == PlatFormType.CbaForum) ? true : false;
    this.collabticDomain = (platformId == PlatFormType.Collabtic) ? true : false;
    if(!this.apiUrl.threadViewPublicPage){
      this.autoMobile = (industryType == 2) ? true : false;
    }
    this.errDtcText = (industryType == 2) ? 'No DTC' : 'No Error Code';

    if(this.domainId == '7'){
      this.KIADomain = true;
    }

    this.fixesView = (this.detailView == 'view-v3') ? true : false;
    if (this.teamSystem) {
      this.msTeamAccess = true;
      if (window.screen.width < 800) {
        this.msTeamAccessMobile = true;
      }
      else{
        this.msTeamAccessMobile = false;
      }
    } else {
      this.msTeamAccess = false;
      this.msTeamAccessMobile = false;
    }

    if(this.collabticDomain){
      if(this.domainId == '386'){
        this.title = 'Repair Order';
        this.shortTitle = 'RO';
      }
      else{
        this.checkTitleParam(); 
      }
    }   
    else{
      this.title = 'Repair Order';
      this.shortTitle = 'RO';
    }


    this.subscription.add(
      this.shopApiCall = this.commonApi.updateRODataReceivedSubject.subscribe((data) => {
        switch(data['action']){
          case 'refresh':
            case 'edit':
            this.openRepairOrderPOPUP('edit',data['id']);
            break;
          default:
            break;
        }

      }));

    this.subscription.add(
      this.commonApi.threadListData.subscribe((r) => {
        console.log(r, this.threadViewData);
        console.log(this.threadViewData.detailType)
        this.isForUser = false;
        this.forPostUser = '';               
        // notification
        if(this.threadViewData.detailType!=undefined && this.threadViewData.detailType!=''){
          
          if(this.threadViewData.detailType == 'postcount'){
            this.threadViewData.comment = r['comment'];
            this.threadViewData.detailType = '';
            return false;
          }
          else if(this.threadViewData.detailType == 'thread-like'){
    
            this.threadViewData.likeStatus = r['likeStatus'];
            this.threadViewData.likeCount =  r['likeCount'];
            this.threadViewData.likedUsers =  r['likedUsers'];
    
            if(this.threadViewData.likedUsers != undefined){
              this.threadViewData.likeStatus = 0;
              for(let a in this.threadViewData.likedUsers) {
                if(this.threadViewData.likedUsers[a] == this.userId) {
                  this.threadViewData.likeStatus = 1;
                }
              }
            }
            this.threadViewData.likeStatus = this.threadViewData.likeStatus;
            this.threadViewData.likeImg = (this.threadViewData.likeStatus == 1) ? 'assets/images/thread-detail/thread-like-active.png' : 'assets/images/thread-detail/thread-like-normal.png';
            this.threadViewData.likeCount = this.threadViewData.likeCount;
            this.threadViewData.likeCountVal = this.threadViewData.likeCount == 0 ? '-' : this.threadViewData.likeCount;
            this.threadViewData.detailType = '';
            return false;
          }
          else if(this.threadViewData.detailType == 'thread-pin'){
    
            this.threadViewData.pinStatus = r['pinStatus'];
              this.threadViewData.pinCount = r['pinCount'];
              this.threadViewData.pinedUsers = r['pinedUsers'];
    
            if(this.threadViewData.pinedUsers != undefined){
              this.threadViewData.pinStatus = 0;
              for(let a in this.threadViewData.pinedUsers) {
                if(this.threadViewData.pinedUsers[a] == this.userId) {
                  this.threadViewData.pinStatus = 1;
                }
              }
            }
    
            this.pinCount = this.threadViewData.pinCount;
            this.pinCountVal = this.threadViewData.pinCount == 0 ? '-' : this.threadViewData.pinCount;
            this.pinStatus = this.threadViewData.pinStatus;
            this.pinImg = (this.threadViewData.pinStatus == 1) ? 'assets/images/thread-detail/thread-pin-active.png' : 'assets/images/thread-detail/thread-pin-normal.png';
            this.threadViewData.detailType = '';
            return false;
          }
          else if(this.threadViewData.detailType == 'thread-plusOne'){
    
            this.threadViewData.plusOneStatus = r['plusOneStatus'];
            this.threadViewData.plusOneCount = r['plusOneCount'];
            this.threadViewData.plusOneUsers = r['plusOneUsers'];
    
            if(this.threadViewData.plusOneUsers != undefined){
              this.threadViewData.plusOneStatus = 0;
              for(let a in this.threadViewData.plusOneUsers) {
                if(this.threadViewData.plusOneUsers[a] == this.userId) {
                  this.threadViewData.plusOneStatus = 1;
                }
              }
            }
            this.plusOneCount = this.threadViewData.plusOneCount;
            this.plusOneCountVal = (this.threadViewData.plusOneCount == 0) ? '-' : this.threadViewData.plusOneCount;
            this.plusOneStatus = this.threadViewData.plusOneStatus;
            this.plusOneImg = (this.threadViewData.plusOneStatus == 1) ? 'assets/images/thread-detail/thread-plus-one-active.png' : 'assets/images/thread-detail/thread-plus-one-normal.png';
            this.threadViewData.detailType = '';
            return false;
          }
          else if(this.threadViewData.detailType == 'comment-postStatus' || this.threadViewData.detailType == 'reply-postStatus'){
            this.threadViewData.fixStatus = r['fixStatus'];
            this.threadViewData.fixPostStatus = r['fixPostStatus'];
            this.threadViewData.detailType = '';
            return false;
          }  
          else if(this.threadViewData.detailType == 'thread-edit' ){
            this.threadViewData.detailType = '';
            this.threadViewData = [];
            this.threadViewData = r;
            this.getThreadInfo();
          }
          else{
            this.threadViewData.detailType = '';
           }          
        }
        // notification
        else{
          if( r['detailType'] == "translate-dupicate" || r['detailType'] == "translate" || r['detailType'] == "thread-content" || r['detailType'] == "thread-sharedfix" || r['detailType'] == "thread-title"
            || r['detailType'] == "thread-invoice" || r['detailType'] == "thread-actiontaken" || r['detailType'] == "thread-teamassist"
          ){
            

            if(r['content'] && r['content'] != undefined){
              this.threadViewData.content = r['content'];            
            }
            if(r['threadDescFix'] && r['threadDescFix'] != undefined){
              this.threadViewData.threadDescFix = r['threadDescFix'];
            }
            if(r['threadTitle'] && r['threadTitle'] != undefined){
              this.threadViewData.threadTitle = r['threadTitle'];
            }
            if(r['customerVoice'] && r['customerVoice'] != undefined){
              this.threadViewData.customerVoice = r['customerVoice'];
            }
            if(r['actionTaken'] && r['actionTaken'] != undefined){
              this.threadViewData.actionTaken = r['actionTaken'];
            }
            if(r['teamAssist'] && r['teamAssist'] != undefined){
              this.threadViewData.teamAssist = r['teamAssist'];
            }
            if(r['transText'] && r['transText'] != undefined){
              this.threadViewData.transText = r['transText'];
            }
            if(r['transId'] && r['transId'] != undefined){
              this.threadViewData.transId = r['transId'];
            }   
            this.threadViewData.detailType = '';        
            return false;
          }
          else{
            console.log(132)
            this.threadViewData = [];
            this.threadViewData = r;
            this.getThreadInfo();
          }
          
        }
        if(this.collabticDomain && this.autoMobile) {
          if(this.WorkOrder!='' && this.WorkOrder != undefined) {
            this.getROInfo();
          }
          this.vinEmpty = (this.threadViewData.vinNo) ? false : true;
          if(this.threadViewData.vinNo) {
            this.nhtsaRecall();
          }
        }
      })
    );
    
    let currUrl = this.router['location']?._platformLocation?.location?.href;
    if(currUrl){
      let urlSplit = currUrl.split('/');
      let checkParam = 'search-page';
      let searchFlag = urlSplit.includes(checkParam);        
      this.searchLoading = (this.expiredSubscription && !searchFlag) ? true : this.searchLoading;
      setTimeout(() => {
        this.detailViewCallBack.emit(this);
      }, 150);
    }

   }
   taponDescription1(content,postData)
   {
 this.commonApi.fetchlangData(content).subscribe(res => {

   console.log(res);
   console.log(res.data.translations[0].translatedText);
   if(res.data.translations[0].translatedText)
   {
     this.threadViewData.threadTitle=res.data.translations[0].translatedText;
   }


 });


   }

   taponDescription2(content,postData)
   {
 this.commonApi.fetchlangData(content).subscribe(res => {

   console.log(res);
   console.log(res.data.translations[0].translatedText);
   if(res.data.translations[0].translatedText)
   {
     this.threadViewData.content=res.data.translations[0].translatedText;
   }


 });


   }

   getEscationInfo(){
    //let dealerLoginTVSIB = localStorage.getItem('dealerLogin');
    //if(dealerLoginTVSIB != '1'){
      if(this.tvsIBDomain){

        if(this.threadViewDataEscation){
          console.log(this.threadViewDataEscation);
          this.escalationDescription = '';
          if(this.threadViewDataEscation.escalationDescriptionArr != undefined && this.threadViewDataEscation.escalationDescriptionArr && this.threadViewDataEscation.escalationDescriptionArr.length>0){ 
            setTimeout(() => {
              this.estooltip.open();
            }, 1000);
          }
          if(this.threadViewDataEscation.escalationDescriptionArr && this.threadViewDataEscation.escalationDescriptionArr.length>0){
            this.escalationDescription='';
          let escalationDescriptionUpdate=this.threadViewDataEscation.escalationDescriptionArr;
          let s = 0;
            for(let desUpdate in escalationDescriptionUpdate) {
              let createdOnNew = escalationDescriptionUpdate[desUpdate].date;
        let createdOnDate = moment.utc(createdOnNew).toDate();
        let createdOnDateEsc = moment(createdOnDate).local().format('MMM DD, YYYY . h:mm A');     
        let nextStr = '';
        if(this.threadViewDataEscation.nextEscStr && this.threadViewDataEscation.nextEscStr!=''){
        nextStr = s == 0 ? '<div class="estext-desp pt-2"><b>Next:</b></div><div class="estext-desp">'+this.threadViewDataEscation.nextEscStr+'</div>' : '';      
        }
        s = s + 1;
    
              //this.escalationDescription += '<div style="margin-top:5px;"><span class="estext-title">'+escalationDescriptionUpdate[desUpdate].title+' on '+createdOnDateEsc+' </span><div *ngIf="escalationDescriptionUpdate[desUpdate].missingEscalation" class="estext-desp" style="padding-bottom: 6px;">'+escalationDescriptionUpdate[desUpdate].missingEscalation+'</div><div class="estext-desp">Note: '+escalationDescriptionUpdate[desUpdate].notes+'</div></div>'
              this.escalationDescription += '<div ><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_icon.png"></span><span class="estext-titleV-text">'+escalationDescriptionUpdate[desUpdate].title+'</span</div><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_calender.png"></span><span class="estext-titleV-text">'+createdOnDateEsc+'</span</div><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_notes.png"></span><span class="estext-titleV-text">'+escalationDescriptionUpdate[desUpdate].notes+'</span</div>'+nextStr+'<div class="main-escV-header"></div></div>'
            }
            setTimeout(() => {
              this.estooltip.open();
            }, 1000);
          } 
          
          this.threadViewData.escalationAction = this.threadViewDataEscation.escalationAction;
          this.threadViewData.escalateStatusLand = this.threadViewDataEscation.escalateStatusLand;
          this.threadViewData.nextEscalationValue = this.threadViewDataEscation.nextEscalationValue;
          this.threadViewData.nextEscalationText = this.threadViewDataEscation.nextEscalationText;
          this.threadViewData.missingEscalationValue = this.threadViewDataEscation.missingEscalationValue;
          this.threadViewData.escColorCodes = this.threadViewDataEscation.escColorCodes;
          this.threadViewData.escColorCodesValue = this.threadViewDataEscation.escColorCodesValue;


          this.escalationAction  = this.threadViewData.escalationAction;
          //this.escalationAction  = '1';
          this.currentEscalation = this.threadViewData.escalateStatusLand;
          this.nextNewEscalation = '';
    
          this.nextNewEscalationText = '';
    
          this.nextEscalation= this.threadViewData.nextEscalationValue;
          this.nextEscalationText= this.threadViewData.nextEscalationText;
          this.missingEscalationValue= this.threadViewData.missingEscalationValue;
    
          switch(this.currentEscalation){
            case 'L1':
              this.currentEscalationText = 'L1';
          //   this.nextEscalation = 'L2';
            // this.nextEscalationText = 'Escalate to L2';
              break;
            case 'L2':
              this.currentEscalationText = 'L2';
            // this.nextEscalation = 'L3';
            // this.nextEscalationText = 'Escalate to L3';
              break;
            case 'L3':
              this.currentEscalationText = 'L3';
            //  this.nextEscalation = 'L4';
            // this.nextEscalationText = 'Escalate to L4';
              break;
            case 'L4':
              this.currentEscalationText = 'L4';
            //  this.nextEscalation = 'L5';
            //  this.nextEscalationText = 'Escalate to L5';
              break;
            case 'L5':
              this.currentEscalationText = 'L5';
            // this.nextEscalation = 'L6';
            //  this.nextEscalationText = 'Escalate to L6';
              //this.nextNewEscalation = 'qadL1';
              //this.nextNewEscalationText = 'QAD L1';
              break;
            case 'L6':
              this.currentEscalationText = 'L6';
            // this.nextEscalation = 'qadL1';
            // this.nextEscalationText = 'QAD L1';
              break;
            case 'qadl1':
            case 'qadL1':
              this.currentEscalationText = 'QAD L1';
            //  this.nextEscalation = 'qadL2';
            //  this.nextEscalationText = 'QAD L2';
              break;
            case 'qadL2':
            case 'qadl2':
              this.currentEscalationText = 'QAD L2';
            //  this.nextEscalation = 'qadL3';
            // this.nextEscalationText = 'QAD L3';
              break;
            case 'qadl3':
            case 'qadL3':
              this.currentEscalationText = 'QAD L3';
            // this.nextEscalation = '';
            // this.nextEscalationText = '';
              break;
            default:
              this.currentEscalationText = '';
              this.nextEscalation = '';
              this.nextEscalationText = '';
            break;
          }

          
          this.escColorCodes = this.threadViewData.escColorCodes;
          this.escColorCodesValue = this.threadViewData.escColorCodesValue;

        }
        else{

        }

      }
   // }
   }
   getThreadInfo(){

    if(this.CBADomain || this.collabticDomain){
      this.AISummaryFlag = this.threadViewData.AISummaryFlag;
      this.AISummary = '';
      this.AISummaryShow = false;
      this.AISummaryAction = '';

      if(this.AISummary == ''){
        this.AISummary = this.threadViewData.summaryaiTextStr && this.threadViewData.summaryaiTextStr != undefined ? this.threadViewData.summaryaiTextStr : '' ;
        if(this.AISummary == ''){
          //this.getAISummary();
        }
      }
    
    }

    if(this.expiredSubscription) {
      return false;
    }
   let highlightSearchStr= localStorage.getItem('highlightSearchStr');
   if(highlightSearchStr)
   {
    
    this.toHighlight=highlightSearchStr;
    this.toHighlight=this.toHighlight.replaceAll(',',' ');
      this.toHighlight=this.toHighlight.trim();
   }
    this.threadCategoryStr = parseInt(this.threadViewData.threadCategoryStr);
    this.modelAttributes = (this.threadViewData.modelAttributes && this.threadViewData.modelAttributes.length > 0) ? this.threadViewData.modelAttributes : [];
    let additionalInfo:any = '';
    if(this.modelAttributes.length > 0) {
      let modelAttr = this.modelAttributes[0];
      //let additionalInfo1 = modelAttr.additionalInfo;
      //let additionalInfo1 = (this.threadViewData.additionalInfo1 && this.threadViewData.additionalInfo1!='') ? JSON.parse(this.threadViewData.additionalInfo1) : '';
      let additionalInfo1 = (this.threadViewData.additionalInfo1 && this.threadViewData.additionalInfo1!='') ? (this.threadViewData.additionalInfo1[0]) : '';
      /*if(this.apiUrl.blackTheameModule) {
        let productMatrix = this.threadViewData.productMatrix;
        if(productMatrix.length > 0) {
          additionalInfo1 = productMatrix[0].additionalInfo[0].name;
        }
      }*/
      let additionalInfo2 = modelAttr.additionalInfo1;
      let additionalInfo3 = modelAttr.additionalInfo2;
      let additionalInfo4 = modelAttr.additionalInfo3;
      let additionalInfo5 = modelAttr.additionalInfo4;
      let additionalInfo6 = modelAttr.additionalInfo5;

      if(additionalInfo1 == '' && !this.collabticFixesDomain){
        additionalInfo1 = modelAttr.additionalInfo;
        if(additionalInfo1 && additionalInfo1.length > 0) { additionalInfo = `${additionalInfo1[0].name}` }
      }
      else{
        if(additionalInfo1!='') { additionalInfo = `${additionalInfo1}` }
      }
      if(additionalInfo2 && additionalInfo2.length > 0) { additionalInfo = `${additionalInfo}, ${additionalInfo2[0].name}` }
      if(additionalInfo3 && additionalInfo3.length > 0) { additionalInfo = `${additionalInfo}, ${additionalInfo3[0].name}` }
      if(additionalInfo4 && additionalInfo4.length > 0) { additionalInfo = `${additionalInfo}, ${additionalInfo4[0].name}` }
      if(additionalInfo5 && additionalInfo5.length > 0) { additionalInfo = `${additionalInfo}, ${additionalInfo5[0].name}` }
      if(additionalInfo6 && additionalInfo6.length > 0) { additionalInfo = `${additionalInfo}, ${additionalInfo6[0].name}` }
    }

    if(this.apiUrl.threadViewPublicPage) {
      this.autoMobile = (this.threadViewData.industryType.id == 2) ? true : false;
    }
    this.additionalInfo = additionalInfo;
    if(this.collabticDomain && this.autoMobile) {
      console.log(this.threadViewData)
      let replacement = 'XXXXXX';
      if(this.threadViewData.vinNo) {
        this.vinEmpty = false;
        this.threadViewData['vinFixes'] = this.threadViewData.vinNo.slice(0, -6) + replacement;
        this.getVinDetail();
      }
    }
    
    let platformId = localStorage.getItem('platformId');
    this.CBADomain = (platformId == PlatFormType.CbaForum) ? true : false;
    this.displayDetail = true;
    console.log(this.threadViewData);
    this.industryType = this.threadViewData.industryType;
    console.log(this.industryType);
    this.threadEdited = this.threadViewData.IsEdited;
    this.threadViewData.comment=this.threadViewData.comment;
    this.threadViewData.contentWeb=this.threadViewData.contentWeb;
    this.threadId = this.threadViewData.threadId; 
    this.postId =  this.threadViewData.postId;
    this.threadViewData.userId = this.threadViewData.userId;
    this.threadViewData.availability = this.threadViewData.availability;

    if(this.roModule){
      this.roBusinessInfoJsonArr = (this.threadViewData.roBusinessInfoJsonArr && (this.threadViewData.roBusinessInfoJsonArr != undefined || this.threadViewData.roBusinessInfoJsonArr != '')) ? this.threadViewData.roBusinessInfoJsonArr : [] ;
      if(this.roBusinessInfoJsonArr.length > 0) {
        this.roBusinessContactInfo = (this.roBusinessInfoJsonArr[0].contactData && this.roBusinessInfoJsonArr[0].contactData != undefined && this.roBusinessInfoJsonArr[0].contactData != '') ? this.roBusinessInfoJsonArr[0].contactData : [];
      }
      console.log(this.roBusinessInfoJsonArr);
    }
    if(this.collabticFixesDomain){

      this.partsDataStrArrFlag = true;
    }
    /*this.userRoleTitle = this.threadViewData.userRoleTitle !='' && this.threadViewData.userRoleTitle != 'undefined' && this.threadViewData.userRoleTitle != undefined ? this.threadViewData.userRoleTitle : '';
    this.userRoleTitle = this.userRoleTitle == '' ? this.threadViewData.badgeStatus : this.threadViewData.badgeStatus+", "+this.userRoleTitle;*/
    this.userRoleTitle = this.threadViewData.userRoleTitle !='' && this.threadViewData.userRoleTitle != undefined ? this.threadViewData.userRoleTitle : this.threadViewData.badgeStatus;
    this.techSubmmitFlag = (this.threadViewData.summitFix == '1') ? true : false;
    console.log(this.techSubmmitFlag);
    this.escalateStatusLand =this.threadViewData.escalateStatusLand != undefined ? this.threadViewData.escalateStatusLand:'';
    if(!this.tvsIBDomain){
      if(this.threadViewData.escalationDescription != undefined && this.threadViewData.escalationDescription != ''){ 
        this.escalationDescription = this.threadViewData.escalationDescription;
        setTimeout(() => {
          this.estooltip.open();
        }, 1000);
      }
      if(this.threadViewData.escalationDescriptionArr){
        this.escalationDescription='';
       let escalationDescriptionUpdate=this.threadViewData.escalationDescriptionArr;
        for(let desUpdate in escalationDescriptionUpdate) {
          let createdOnNew = escalationDescriptionUpdate[desUpdate].date;
    let createdOnDate = moment.utc(createdOnNew).toDate();
    let createdOnDateEsc = moment(createdOnDate).local().format('MMM DD, YYYY . h:mm A');

          //this.escalationDescription += '<div style="margin-top:5px;"><span class="estext-title">'+escalationDescriptionUpdate[desUpdate].title+' on '+createdOnDateEsc+' </span><div *ngIf="escalationDescriptionUpdate[desUpdate].missingEscalation" class="estext-desp" style="padding-bottom: 6px;">'+escalationDescriptionUpdate[desUpdate].missingEscalation+'</div><div class="estext-desp">Note: '+escalationDescriptionUpdate[desUpdate].notes+'</div></div>'
          this.escalationDescription += '<div ><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_icon.png"></span><span class="estext-titleV-text">'+escalationDescriptionUpdate[desUpdate].title+'</span</div><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_calender.png"></span><span class="estext-titleV-text">'+createdOnDateEsc+'</span</div><div><span class="estext-titleV-img" style="vertical-align:text-bottom"><img src="assets/images/thread-detail/escalation_esc_notes.png"></span><span class="estext-titleV-text">'+escalationDescriptionUpdate[desUpdate].notes+'</span</div><div class="main-escV-header"></div></div>'
        }
        setTimeout(() => {
          this.estooltip.open();
        }, 1000);
      }  
      
      this.escalationAction  = this.threadViewData.escalationAction;
      //this.escalationAction  = '1';
      this.currentEscalation = this.threadViewData.escalateStatusLand;
      this.nextNewEscalation = '';

      this.nextNewEscalationText = '';

      this.nextEscalation= this.threadViewData.nextEscalationValue;
      this.nextEscalationText= this.threadViewData.nextEscalationText;
      this.missingEscalationValue= this.threadViewData.missingEscalationValue;

      switch(this.currentEscalation){
        case 'L1':
          this.currentEscalationText = 'L1';
       //   this.nextEscalation = 'L2';
         // this.nextEscalationText = 'Escalate to L2';
          break;
        case 'L2':
          this.currentEscalationText = 'L2';
         // this.nextEscalation = 'L3';
         // this.nextEscalationText = 'Escalate to L3';
          break;
        case 'L3':
          this.currentEscalationText = 'L3';
        //  this.nextEscalation = 'L4';
         // this.nextEscalationText = 'Escalate to L4';
          break;
        case 'L4':
          this.currentEscalationText = 'L4';
        //  this.nextEscalation = 'L5';
        //  this.nextEscalationText = 'Escalate to L5';
          break;
        case 'L5':
          this.currentEscalationText = 'L5';
         // this.nextEscalation = 'L6';
        //  this.nextEscalationText = 'Escalate to L6';
          //this.nextNewEscalation = 'qadL1';
          //this.nextNewEscalationText = 'QAD L1';
          break;
        case 'L6':
          this.currentEscalationText = 'L6';
         // this.nextEscalation = 'qadL1';
         // this.nextEscalationText = 'QAD L1';
          break;
        case 'qadl1':
        case 'qadL1':
          this.currentEscalationText = 'QAD L1';
        //  this.nextEscalation = 'qadL2';
        //  this.nextEscalationText = 'QAD L2';
          break;
        case 'qadL2':
        case 'qadl2':
          this.currentEscalationText = 'QAD L2';
        //  this.nextEscalation = 'qadL3';
         // this.nextEscalationText = 'QAD L3';
          break;
        case 'qadl3':
        case 'qadL3':
          this.currentEscalationText = 'QAD L3';
         // this.nextEscalation = '';
         // this.nextEscalationText = '';
          break;
        default:
          this.currentEscalationText = '';
          this.nextEscalation = '';
          this.nextEscalationText = '';
        break;
      }

    

    this.escColorCodes = this.threadViewData.escColorCodes;
    this.escColorCodesValue = this.threadViewData.escColorCodesValue;
    }
    this.threadViewData.techSubmmitFlag = this.techSubmmitFlag;

    if(this.threadViewData.techSubmmitFlag || this.tvsDomain){
      if(this.threadViewData.technicianInfoJsonArr != undefined && this.threadViewData.technicianInfoJsonArr)
      {   
        if(this.threadViewData.technicianInfoJsonArr.length>0){  
          let techinfo = this.threadViewData.technicianInfoJsonArr[0];
          this.technicianId = techinfo.id;
          this.threadViewData.userName = techinfo.name;
          this.threadViewData.profileImage = techinfo.profileImg;
        }
      }
      let dealerInfo:any;
      if(this.displayDetail){
        dealerInfo = (this.threadViewData.dealerInfoJsonArr !="" && this.threadViewData.dealerInfoJsonArr != undefined) ? this.threadViewData.dealerInfoJsonArr[0] : '';
      }
      else{
        dealerInfo = (this.threadViewData.dealerInfo !="" && this.threadViewData.dealerInfo != undefined) ? this.threadViewData.dealerInfo[0] : '';
      }

     
            
      //this.userRoleTitle = dealerInfo.dealerName != '' ? this.userRoleTitle+", "+dealerInfo.dealerName : this.userRoleTitle ;
    }
    else{
      this.threadViewData.userName = this.threadViewData.userName;
      let firstNameSplit = this.threadViewData.userName ? this.threadViewData.userName.split(' ') : this.threadViewData.userName;
      this.threadViewData.firstName = firstNameSplit[0];
      this.threadViewData.profileImage = this.threadViewData.profileImage;
    }

    this.threadUserId = this.threadViewData.userId;

    if(this.userId == this.threadUserId || this.threadViewData.ownerAccess == 1){
      this.threadOwner = true;
    }
    else{
      this.threadOwner = false;
    }

    if(this.domainId!=this.threadViewData.domainId)
    {
      //this.threadOwner = true;
    }

    if(this.CBADomain) {
      let wsItem = this.threadViewData.WorkstreamsList;
      let wsId = wsItem[0].workstreamId
      this.threadCatgFlag = (wsId == 1) ? false : this.threadCatgFlag;
      this.scanToolFlag = (this.threadViewData.scanToolFlag && this.threadViewData.scanToolFlag[0] == 1) ? true : false;
      if(this.scanToolFlag) {
        this.scanVersion = this.threadViewData.scanVersion;
      } 
    } else {
      this.scanVersion = (this.threadViewData.scanVersion && this.threadViewData.scanVersion != undefined) ? this.threadViewData.scanVersion : '';
    }

    if(platformId == PlatFormType.Collabtic && (this.domainId == 1 || this.domainId == 267)) {
      let threadCatgData = this.threadViewData.threadCategoryData;
      if(Array.isArray(threadCatgData) && threadCatgData.length > 0) {
        let threadCatgId = parseInt(threadCatgData[0].id);
        this.ricohFlag = (threadCatgId == 6) ? true : false;
      }
      this.locationVal = this.threadViewData.location;
      this.ipAddr = this.threadViewData.ipAddress;
      this.severityLevel = this.threadViewData.serverityLevelName;
      this.userLoginMethod = this.threadViewData.userLoginMethodName;
      this.userAffectedDomain = this.threadViewData.affectedUserDomain;
      let replace = /,/gi;
      //this.threadViewData.userEmailAddress = this.threadViewData.userEmailAddress.replace(replace, ", ");
      //this.userEmailAddr = this.threadViewData.userEmailAddress;

      let userEmailAddr: any = this.threadViewData.userEmailAddressData;
      if(Array.isArray(userEmailAddr)) {
        userEmailAddr = userEmailAddr.join(', ');
        this.userEmailAddr = userEmailAddr;
      }
    }

    if(this.threadViewData.forPostedByInt) {
      console.log(this.threadViewData)
      this.isForUser = (this.threadViewData.forPostedByInt > 0) ? true : false;
      this.forPostUser = (this.isForUser) ? this.threadViewData.forPostedByUserStr : '';
     
      console.log(this.isForUser, this.forPostUser)
    }
    this.threadPostedByCustomerInt=this.threadViewData.threadPostedByCustomerInt;
    if(this.threadViewData.threadPostedByCustomerInt=='1')
    {
      this.threadPostedByCustomerStr='Customer';
    }
    else
    {
      this.threadPostedByCustomerStr='Tech Support';
    }
    


    let createdOnNew = this.threadViewData.createdOnNew;
    let createdOnDate = moment.utc(createdOnNew).toDate();
    this.threadCreatedOn = moment(createdOnDate).local().format('MMM DD, YYYY . h:mm A');
    //this.threadCreatedOn = moment(createdOnDate).local().format('MMM DD, h:mm A');
    console.log(this.threadViewData.createdOnNew);


    let localcreatedOnformat = moment(createdOnDate)
    let currentTime=moment().local().format('MM/DD/YY HH:mm:ss');     
    let timeToCloseMin1 = moment(currentTime).utc().diff(localcreatedOnformat, 'seconds');

    if(!this.endUser && this.roModule && this.customerPriority && this.aetoolsDomain) {
      this.apiUrl.reason = false;  
      if((this.threadViewData.roBusinessInfoJsonArr.length > 0 && this.threadViewData.roBusinessInfoJsonArr[0].hasOwnProperty('customerSLA') && this.threadViewData.roBusinessInfoJsonArr[0].customerSLA != '')){
        this.getReasonHistory();
      }      
    }  
    this.closeStatus = this.threadViewData.closeStatus;
    if(this.closeStatus == 0){
      var now = moment(new Date()); //todays date
      var end = moment(createdOnDate).local().format('YYYY-MM-DD'); // another date
      var duration = moment.duration(now.diff(end));
      var days = duration.asDays();
      this.opendaysCount = Math.trunc(days);
      this.opendaysFlag = this.opendaysCount==0 ? true : false;
      this.opendaysCount = this.opendaysCount>1 ? 'open '+this.opendaysCount+' days' :  'open '+this.opendaysCount+' day';
    }

    this.threadPosted = this.threadViewData.postedFrom == '' ? '' : this.threadViewData.postedFrom;
    this.threadViewData.vinNo = (this.threadViewData.vinNo && this.threadViewData.vinNo != undefined && this.threadViewData.vinNo != 0) ? this.threadViewData.vinNo : '';
    this.threadViewData.year = (this.threadViewData.year && this.threadViewData.year != undefined && this.threadViewData.year != 0) ? this.threadViewData.year : '';
    this.serialNo = this.threadViewData.serialNo != '' && this.threadViewData.serialNo != null ? this.threadViewData.serialNo : '';
    this.year = this.threadViewData.year;
    if(this.industryType.id != 2) {
      this.trim1 = (this.threadViewData.trim1 != "" && this.threadViewData.trim1 != "[]" && this.threadViewData.trim1 != undefined && this.threadViewData.trim1.length>0) ? this.threadViewData.trim1 : '';
      this.trim2 = (this.threadViewData.trim2 != "" && this.threadViewData.trim2 != "[]" && this.threadViewData.trim2 != undefined && this.threadViewData.trim2.length>0) ? this.threadViewData.trim2 : '';
      this.trim3 = (this.threadViewData.trim3 != "" && this.threadViewData.trim3 && this.threadViewData.trim3.length>0) ? this.threadViewData.trim3 : '';
      if(this.trim1 != ''){
        if(this.trim2 != ''){
          if(this.trim3 != ''){
            this.trim = this.trim1+", "+this.trim2+", "+this.trim3;
          }
          else{
            this.trim = this.trim1+", "+this.trim2;
          }
        }
        else{
          if(this.trim3 != ''){
            this.trim = this.trim1+", "+this.trim3;
          }
          else{
            this.trim = this.trim1;
          }
        }
      }
      else{
        if(this.trim2 != ''){
          if(this.trim3 != ''){
            this.trim = this.trim2+", "+this.trim3;
          }
          else{
            this.trim = this.trim2;
          }
        }
        else{
          if(this.trim3 != ''){
            this.trim = this.trim3;
          }
          else{
            this.trim = "";
          }
        }
      }
    }

    if(this.industryType.id == 2) {
      /*this.trim = '';
      this.trim1 = (this.threadViewData.trim1 != "" && this.threadViewData.trim1 != "[]" && this.threadViewData.trim1.length>0) ? this.threadViewData.trim1[0].name : '';
      this.trim2 = (this.threadViewData.trim2 != "" && this.threadViewData.trim2 != "[]" && this.threadViewData.trim2.length>0) ? this.threadViewData.trim2[0].name : '';
      this.trim3 = (this.threadViewData.trim3 != "" && this.threadViewData.trim3 != "[]" && this.threadViewData.trim3.length>0) ? this.threadViewData.trim3 : '';
      this.trim4 = (this.threadViewData.trim4 != "" && this.threadViewData.trim4 != "[]" && this.threadViewData.trim4.length>0) ? this.threadViewData.trim4[0].name : '';
      this.trim5 = (this.threadViewData.trim5 != "" && this.threadViewData.trim5 != "[]" && this.threadViewData.trim5.length>0) ? this.threadViewData.trim5[0].name : '';
      this.trim6 = (this.threadViewData.trim6 != "" && this.threadViewData.trim6 != "[]" && this.threadViewData.trim6.length>0) ? this.threadViewData.trim6[0].name : '';
      this.trim  = (this.trim1 != '') ? this.trim1 : '';
      this.trim  = (this.trim2 != '') ? `${this.trim}, ${this.trim2}` : this.trim;
      this.trim  = (this.trim3 != '') ? `${this.trim}, ${this.trim3}` : this.trim;
      this.trim  = (this.trim4 != '') ? `${this.trim}, ${this.trim4}` : this.trim;
      this.trim  = (this.trim5 != '') ? `${this.trim}, ${this.trim5}` : this.trim;
      this.trim  = (this.trim6 != '') ? `${this.trim}, ${this.trim6}` : this.trim;
      this.trim = (this.trim.length && this.trim[0] === ',') ? this.trim.substring(1) : this.trim;
      this.trim = (this.trim.length && this.trim[0] === ' ') ? this.trim.substring(1) : this.trim;*/
      this.automobileFlag = true;
      this.automobileDefaultImg = (this.threadViewData.isDefaultBanner == 0) ? false : true;

      /*this.threadViewData.trims = [];

      if(this.industryType.id == 2) {
        this.trim1 = (this.threadViewData.trim1 != "" && this.threadViewData.trim1 != "[]" && this.threadViewData.trim1.length>0) ? this.threadViewData.trim1[0] : '';
        if(this.trim1 != ''){
          this.threadViewData.trims.push({
            key: this.trim1['key'],
            id: this.trim1['id'],
            name: this.trim1['name']
          });
        }
        this.trim2 = (this.threadViewData.trim2 != "" && this.threadViewData.trim2 != "[]" && this.threadViewData.trim2.length>0) ? this.threadViewData.trim2[0] : '';
        if(this.trim2 != ''){
          this.threadViewData.trims.push({
            key: this.trim2['key'],
            id: this.trim2['id'],
            name: this.trim2['name']
          });
        }
        this.trim3 = (this.threadViewData.trim3 != "" && this.threadViewData.trim3 != "[]" && this.threadViewData.trim3.length>0) ? this.threadViewData.trim3[0] : '';
        if(this.trim3 != ''){
          this.threadViewData.trims.push({
            key: this.trim3['key'],
            id: this.trim3['id'],
            name: this.trim3['name']
          });
        }
        this.trim4 = (this.threadViewData.trim4 != "" && this.threadViewData.trim4 != "[]" && this.threadViewData.trim4.length>0) ? this.threadViewData.trim4[0] : '';
        if(this.trim4 != ''){
          this.threadViewData.trims.push({
            key: this.trim4['key'],
            id: this.trim4['id'],
            name: this.trim4['name']
          });
        }
        this.trim5 = (this.threadViewData.trim5 != "" && this.threadViewData.trim5 != "[]" && this.threadViewData.trim5.length>0) ? this.threadViewData.trim5[0] : '';
        if(this.trim5 != ''){
          this.threadViewData.trims.push({
            key: this.trim5['key'],
            id: this.trim5['id'],
            name: this.trim5['name']
          });
        }
        this.trim6 = (this.threadViewData.trim6 != "" && this.threadViewData.trim6 != "[]" && this.threadViewData.trim6.length>0) ? this.threadViewData.trim6[0] : '';
        if(this.trim6 != ''){
          this.threadViewData.trims.push({
            key: this.trim6['key'],
            id: this.trim6['id'],
            name: this.trim6['name']
          });
        }
        this.trim = (this.trim1 == '' &&  this.trim2 == '' && this.trim3 == '' && this.trim4 == '' && this.trim5 == '' && this.trim6 == '') ? '' : 'trim';
        console.log(this.trim);

        if(this.threadViewData.trims!=''){
          if(this.threadViewData.trims.length>3){
            this.trimborder = true;
          }
        }
        console.log(this.threadViewData.trims);

      }*/
    }

    if(this.collabticFixesDomain && this.threadViewData.init == 'init'){         
      this.resolutionDefaultFlag = true;      
      console.log(this.threadViewData.threadFixModelDataStr);
      if(this.llmSummary == ''){
      this.llmSummary = this.threadViewData.threadFixModelDataStr && this.threadViewData.threadFixModelDataStr != undefined ? this.threadViewData.threadFixModelDataStr : '' ;
      }
      if(this.llmSummary == ''){ 
        this.llmSummary = this.threadViewData.threadFixDataStr && this.threadViewData.threadFixDataStr !='' ? this.threadViewData.threadFixDataStr : '' ;
      }


      if(this.llmSummary == ''){ 
       setTimeout(() => {
        this.llmSummaryLoading = true;
        this.getSolrSummary(this.threadViewData.threadId);
       }, 300);        
      }      
    }
    else{
      if(this.apiUrl.blackTheameModule){
        this.llmSummary = this.apiUrl.llmSummary;
      }
    }

    if(this.llmSummary != ''){      
      this.llmSummary = this.llmSummary.replace("<p>Issues:</p>", "<p class='summary-highlight-color'>Issues:</p>");
      this.llmSummary = this.llmSummary.replace("<p>Resolutions:</p>", "<p class='summary-highlight-color'>Resolutions:</p>");
      this.llmSummaryLoading = false;
    }    

    if(this.collabticFixesDomain) {
      this.timeApproxtoFixStr = "0";
      let checkValue = "1";
      let timeApproxtoFixStr:any = (this.threadViewData.timeApproxtoFixStr) ? this.threadViewData.timeApproxtoFixStr : this.timeApproxtoFixStr;
      timeApproxtoFixStr = (timeApproxtoFixStr == "0") ? '-' : (timeApproxtoFixStr == checkValue) ? `${timeApproxtoFixStr} Hour` : `${timeApproxtoFixStr} Hours`;
      this.timeApproxtoFixStr = timeApproxtoFixStr;
    }
    
    let hoursforFix = this.threadViewData.hoursforFix != '' && this.threadViewData.hoursforFix != null ? this.threadViewData.hoursforFix : '';
    if(this.domainId=='342')
    {
      let checkValueEuro = "1";
      hoursforFix = (hoursforFix == "0") ? '-' : (hoursforFix > checkValueEuro) ? `${hoursforFix}` : `${hoursforFix} Hour`;
    

    }
    let minforFix = this.threadViewData.minforFix != '' && this.threadViewData.minforFix != null ? this.threadViewData.minforFix : '';
    if(hoursforFix != "" && minforFix != "" ){
      this.shareFixHours = hoursforFix+" - "+minforFix;
    }
    else if(hoursforFix != "" && minforFix == "" ){
      this.shareFixHours = hoursforFix;
    }
    else if(hoursforFix == "" && minforFix != "" ){
      this.shareFixHours = minforFix;
    }
    else{
      this.shareFixHours = "";
    }
    
    this.WorkOrder = this.threadViewData.WorkOrder !='' && this.threadViewData.WorkOrder != null ? this.threadViewData.WorkOrder : '';
    this.WorkOrder = this.threadViewData.workOrder !='' && this.threadViewData.workOrder != null ? this.threadViewData.workOrder : this.WorkOrder;
   console.log(this.WorkOrder +'--'+this.threadViewData.WorkOrder);
    this.odometer = this.threadViewData.odometer !='' && this.threadViewData.odometer != null ? this.threadViewData.odometer : '' ;
    this.miles = this.threadViewData.miles !='' && this.threadViewData.miles != null ? this.threadViewData.miles : '';

    if(this.tvsDomain){
      this.kaizenCategory = this.threadViewData.kaizenCategory !='' && this.threadViewData.kaizenCategory != null ? this.threadViewData.kaizenCategory : '';
      // this.tvsSystem = this.threadViewData.systemSelection !='' && this.threadViewData.systemSelection != null ? this.threadViewData.systemSelection : '';
      // this.repairOrder = this.threadViewData.repairOrder !='' && this.threadViewData.repairOrder != null ? this.threadViewData.repairOrder : '';
      this.occrance = this.threadViewData.occrance !='' && this.threadViewData.occrance != null ? this.threadViewData.occrance : '';
       
      if(this.displayDetail){
        this.productCoordinator = (this.threadViewData.productCoordinatorJsonArr && this.threadViewData.productCoordinatorJsonArr != undefined) ? this.threadViewData.productCoordinatorJsonArr[0] : '';
        this.territoryManager = (this.threadViewData.territoryManagerJsonArr && this.threadViewData.territoryManagerJsonArr != undefined) ? this.threadViewData.territoryManagerJsonArr : '';
        this.technicianInfo = (this.threadViewData.technicianInfoJsonArr && this.threadViewData.technicianInfoJsonArr != undefined) ? this.threadViewData.technicianInfoJsonArr[0] : '';
     
      }

      if(this.productCoordinator == ''){
      this.productCoordinator = (this.threadViewData.productCoordinator && this.threadViewData.productCoordinator != undefined) ? this.threadViewData.productCoordinator[0] : '';
      }
      if(this.territoryManager == ''){
      this.territoryManager = (this.threadViewData.territoryManager && this.threadViewData.territoryManager != undefined) ? this.threadViewData.territoryManager : '';
      }
      if(this.technicianInfo == ''){
      this.technicianInfo = (this.threadViewData.technicianInfo && this.threadViewData.technicianInfo != undefined) ? this.threadViewData.technicianInfo[0] : '';
      }
      
      console.log( this.territoryManager);
    }

    if(this.CBADomain) {
      let workOrder = this.threadViewData.workOrder;
      if(workOrder != '') {
        this.WorkOrder = workOrder;
        this.repairOrderLink = this.threadViewData.roUrl;
        this.dviPdfUrlLink = this.threadViewData.dviPdfUrl;
      }
      this.scanVinInfo = (this.threadViewData.scanVinInfo && this.threadViewData.scanVinInfo != '') ? JSON.parse(this.threadViewData.scanVinInfo) : this.threadViewData.scanVinInfo;
    }

    if(this.autoShopAnswersDomain) {
      let workOrder = this.threadViewData.workOrder;
      if(workOrder != '') {
        this.WorkOrder = workOrder;
        let roData = {
          roId: workOrder
        };
        this.baseSerivce.get("forum", "Getrobyid", roData).subscribe((response: any) => {
          let resultData = response.items;
          if(resultData.length > 0) {
            let resultItems = resultData[0];
            if(this.threadViewData.vinNo && resultItems.vin) {
              this.repairOrderLink = resultItems.ro_url;
              this.estimateLink = resultItems.estimateUrl;
              this.inspectionLink = resultItems.inspectionUrl;
              this.invoiceLink = resultItems.invoiceUrl;
            }
          }
        });        
      }
    }

    if(this.odometer != ''){
      console.log(this.odometer);
      this.odometer = this.commonApi.removeCommaNum(this.odometer);
      if(this.tvsDomain) {
        this.odometer = this.commonApi.numberWithCommasTwoDigit(this.odometer);
      }
      else{
        this.odometer = this.commonApi.numberWithCommasThreeDigit(this.odometer);
      }
      this.milesOdometer = this.odometer+" "+this.miles;
    }

    this.curentDtclength = 0;
    if(this.collabticFixesDomain){
      
      if (this.threadViewData.dtcDefinitionJsonArr && this.threadViewData.dtcDefinitionJsonArr.length > 0) {
        this.oldDtcFlag = false;
        this.curentDtclength = this.threadViewData.dtcDefinitionJsonArr.length;
        //this.curentDtcData = this.threadViewData.currentDtc;
        this.curentDtcData = [];
        let dtcList = [];
        this.threadViewData.dtcDefinitionJsonArr.forEach(dtc => {
          let dtcCode = dtc.dtc_code;
          let dtcDesc = dtc.description;
          let cdtcItem = (dtc.description != '') ? `${dtcCode} ${dtcDesc}` : dtcCode;
          let cdtcIndex = this.curentDtcData.findIndex(option => option.dtcItem == cdtcItem);
          if(cdtcIndex < 0) {
            dtc.dtcItem = cdtcItem;
            this.curentDtcData.push(dtc);
          }
        });
        this.curentDtcData.forEach((item, i) => {
          let dtcItem = item.dtc_code;
          let dtcIndex = dtcList.findIndex(option => option == dtcItem);
          if(dtcIndex < 0) {
            dtcList.push(dtcItem);
          }
        });
        dtcList.forEach((ditem, di) => {
          //let seperator = (dtcList.length > 1 && dtcList.length < di) ? ',' : '';
          //dtcList[di] = (di > 0) ? `${seperator} ${dtcList[di]}` : dtcList[di];
        });
        this.currentDtcList = dtcList;
      }
      else{
        if (this.threadViewData.currentDtcStrArr && this.threadViewData.currentDtcStrArr.length > 0) {
          this.oldDtcFlag = true;
          this.curentDtclength = this.threadViewData.currentDtcStrArr.length;
          this.curentDtcData = this.threadViewData.currentDtcStrArr;
          this.currentDtcList = [];
          let dtcList = [];          
          this.curentDtcData.forEach((item, i) => {
            let dtcItem = item;
            let dtcIndex = dtcList.findIndex(option => option == dtcItem);
            if(dtcIndex < 0) {
              dtcList.push(dtcItem);
            }
          });
          this.currentDtcList = dtcList;
        }
      }

      if (this.threadViewData.dezCodesStrArr && this.threadViewData.dezCodesStrArr.length > 0) {
          
        let dezCodesStrArrData=this.threadViewData.dezCodesStrArr;          
        //errorCodesArr = viewData[t].dezCodesStrArr;
        for(let dez in dezCodesStrArrData)
        {
          this.currentDtcList.push(dezCodesStrArrData[dez]);
        }
      }
      if (this.threadViewData.hexCodesStrArr && this.threadViewData.hexCodesStrArr.length > 0) {
             
        let hexCodesStrArrData=this.threadViewData.hexCodesStrArr;          
        //errorCodesArr = viewData[t].dezCodesStrArr;
        for(let hez in hexCodesStrArrData)
        {
          this.currentDtcList.push(hexCodesStrArrData[hez]);
        }
      }

    }
    else{
    if (this.threadViewData.currentDtc && this.threadViewData.currentDtc.length > 0) {
      this.curentDtclength = this.threadViewData.currentDtc.length;
      //this.curentDtcData = this.threadViewData.currentDtc;
      this.curentDtcData = [];
      let dtcList = [];
      this.threadViewData.currentDtc.forEach(dtc => {
        let dtcCode = dtc.code;
        let dtcDesc = dtc.description;
        let cdtcItem = (dtc.description != '') ? `${dtcCode} ${dtcDesc}` : dtcCode;
        let cdtcIndex = this.curentDtcData.findIndex(option => option.dtcItem == cdtcItem);
        if(cdtcIndex < 0) {
          dtc.dtcItem = cdtcItem;
          this.curentDtcData.push(dtc);
        }
      });
      this.curentDtcData.forEach((item, i) => {
        let dtcItem = item.code;
        let dtcIndex = dtcList.findIndex(option => option == dtcItem);
        if(dtcIndex < 0) {
          dtcList.push(dtcItem);
        }
      });
      dtcList.forEach((ditem, di) => {
        //let seperator = (dtcList.length > 1 && dtcList.length < di) ? ',' : '';
        //dtcList[di] = (di > 0) ? `${seperator} ${dtcList[di]}` : dtcList[di];
      });
      this.currentDtcList = dtcList;
    }
  }
    this.taglength = 0;
    if (this.threadViewData.tags && this.threadViewData.tags.length > 0) {
      this.taglength = this.threadViewData.tags.length;
      this.tagData = this.threadViewData.tags;
    }
    console.log(this.threadViewData.partsDataStrArr)
    console.log(this.threadViewData.partsDataJsonArr)

    this.partsData=[];
    this.partslength=0;
    if(this.partsDataStrArrFlag){
      if (this.threadViewData.partsDataJsonArr) {
        let arrVal = (this.threadViewData.partsDataJsonArr);
        console.log(arrVal)
        this.partslength = arrVal.length;
        if(this.partslength>0){
          for(let st in arrVal){
            let id = arrVal[st].id;
            let partDesc = arrVal[st].partDesc;
            let partNumber = arrVal[st].partNumber;
            let partData = "Part# "+partNumber+" - "+partDesc;
            console.log(partData)
            this.partsData.push(partData);
          }
          console.log(this.partsData)
        }

      }
    }


    this.categoryLength = 0;
    this.categoryData = this.threadViewData.prodappId !='' && this.threadViewData.prodappId != null ? this.threadViewData.prodappId : '';
    if(this.categoryData!= '' ){ this.categoryLength = this.categoryData.length;}

    this.subCategoryLength = 0;
    this.subCategoryData = this.threadViewData.prodcatId !='' && this.threadViewData.prodcatId != null ? this.threadViewData.prodcatId : '';
    this.subCategoryLength = this.subCategoryData.length;

    this.productTypeLength = 0;
    this.productTypeData = this.threadViewData.prodtypeId !='' && this.threadViewData.prodtypeId != null ? this.threadViewData.prodtypeId : '';
    this.productTypeLength = this.productTypeData.length;

    this.regionsLength = 0;
    this.regionsData = this.threadViewData.regions !='' && this.threadViewData.regions != null ? this.threadViewData.regions : '';
    this.regionsLength = this.regionsData.length;

    this.likeCount = this.threadViewData.likeCount;
    this.threadViewData.likeCount = this.threadViewData.likeCount;
    this.threadViewData.likeCountVal = this.threadViewData.likeCount == 0 ? '-' : this.threadViewData.likeCount;
    if(this.viewVersion2){
      if(this.threadViewData.likedUsers != undefined){
        this.threadViewData.likeStatus = 0;
        for(let a in this.threadViewData.likedUsers) {
          if(this.threadViewData.likedUsers[a] == this.userId) {
            this.threadViewData.likeStatus = 1;
          }
        }
      }
    }

    this.threadViewData.likeImg = (this.threadViewData.likeStatus == 1) ? 'assets/images/thread-detail/thread-like-active.png' : 'assets/images/thread-detail/thread-like-normal.png';

    if(this.viewVersion2){
      if(this.threadViewData.pinedUsers != undefined){
        this.threadViewData.pinStatus = 0;
        for(let a in this.threadViewData.pinedUsers) {
          if(this.threadViewData.pinedUsers[a] == this.userId) {
            this.threadViewData.pinStatus = 1;
          }
        }
      }
    }
    this.pinCount = this.threadViewData.pinCount;
    this.pinCountVal = this.threadViewData.pinCount == 0 ? '-' : this.threadViewData.pinCount;
    this.pinStatus = this.threadViewData.pinStatus;
    this.pinImg = (this.threadViewData.pinStatus == 1) ? 'assets/images/thread-detail/thread-pin-active.png' : 'assets/images/thread-detail/thread-pin-normal.png';

    if(this.viewVersion2){
      if(this.threadViewData.plusOneUsers != undefined){
        this.threadViewData.plusOneStatus = 0;
        for(let a in this.threadViewData.plusOneUsers) {
          if(this.threadViewData.plusOneUsers[a] == this.userId) {
            this.threadViewData.plusOneStatus = 1;
          }
        }
      }
    }
    this.plusOneCount = this.threadViewData.plusOneCount;
    this.plusOneCountVal = (this.threadViewData.plusOneCount == 0) ? '-' : this.threadViewData.plusOneCount;
    this.plusOneStatus = this.threadViewData.plusOneStatus;
    this.plusOneImg = (this.threadViewData.plusOneStatus == 1) ? 'assets/images/thread-detail/thread-plus-one-active.png' : 'assets/images/thread-detail/thread-plus-one-normal.png';

    if(!this.loadServiceFlag){
      this.audioDesc = [];
      if(this.threadViewData.audioDescription) {
        let a = 0;
        this.audioDesc = this.threadViewData.audioDescription;
      }
      this.attachments = [];
      this.attachmentLoading = true;
      if((this.threadViewData.uploadContents && this.threadViewData.uploadContents.length>0)){
        this.attachments = this.threadViewData.uploadContents;
        setTimeout(() => {
          this.attachmentLoading = false;
        }, 100);
      }

       }
      let likeCount = this.commonApi.formatCompactNumber(this.likeCount);
      let pinCount = this.commonApi.formatCompactNumber(this.pinCount);
      let viewCountHover = (this.threadViewData.viewCount);
      let viewCount = this.commonApi.formatCompactNumber(this.threadViewData.viewCount);      
      this.threadViewData.likeCount = likeCount;
      this.threadViewData.pinCount = pinCount;
      this.threadViewData.viewCount = viewCount;
      this.threadViewData.viewCountHover = viewCountHover;
       
    this.threadViewData.causeOfProblem = (this.threadViewData.causeOfProblem != undefined && this.threadViewData.causeOfProblem !=  '') ? this.threadViewData.causeOfProblem : '' ;
    if(this.threadViewData.editHistory != undefined){
        let editdata =this.threadViewData.editHistory;
        for (let ed in editdata) {
        let editdate1 = editdata[ed].updatedOnNew;
        let editdate2 = moment.utc(editdate1).toDate();
        editdata[ed].updatedOnNew = moment(editdate2).local().format('MMM DD, YYYY . h:mm A');
      }
    }

    setTimeout(() => {
      this.loading = false;
      this.detailViewCallBack.emit(this);
    }, 100);
   }

   gotoPosition(val){
    this.activePosition.emit(val);
   }


   // Like, Pin and OnePlus Action
  socialAction(type, status) {
    console.log(type,status);
    let actionStatus = '';
    let actionFlag = true;
    let pinCount = this.pinCount;
    let likeCount = this.threadViewData.likeCount;
    let plusOneCount = this.plusOneCount;
    let url = RedirectionPage.Threads;
    let getNavDet = this.checkNavEdit(url);
    let pageDataInfo = getNavDet.dataInfo;
    setTimeout(() => {
      localStorage.setItem(getNavDet.navEditText, 'true')
    }, 150);
    switch(type) {
      case 'like':
      actionFlag = (this.threadViewData.likeLoading) ? false : true;
      actionStatus = (status == 0) ? 'liked' : 'disliked';
      this.threadViewData.likeStatus = (status == 0) ? 1 : 0;
      this.threadViewData.likeStatus = this.threadViewData.likeStatus;
      this.threadViewData.likeImg = (this.threadViewData.likeStatus == 1) ? 'assets/images/thread-detail/thread-like-active.png' : 'assets/images/thread-detail/thread-like-normal.png';
      this.threadViewData.likeCount = (status == 0) ? likeCount+1 : likeCount-1;
      this.threadViewData.likeCount = this.commonApi.formatCompactNumber(this.threadViewData.likeCount);
      this.threadViewData.likeCount = this.threadViewData.likeCount;
      this.threadViewData.likeCountVal = this.threadViewData.likeCount == 0 ? '-' : this.threadViewData.likeCount;
      this.likeActionText = (status == 0) ? 'Liked' : 'Disliked';
      this.likeModal = true;
      setTimeout(() => {
        this.likeActionText = '';
        this.likeModal = false;
      }, 1200);
      break;
      case 'pin':
      actionFlag = (this.pinLoading) ? false : true;
      actionStatus = (status == 0) ? 'pined' : 'dispined';
      this.pinStatus = (status == 0) ? 1 : 0;
      this.pinImg = (this.pinStatus == 1) ? 'assets/images/thread-detail/thread-pin-active.png' : 'assets/images/thread-detail/thread-pin-normal.png';
      this.pinCount = (status == 0) ? pinCount+1 : pinCount-1;
      this.threadViewData.pinCount = this.commonApi.formatCompactNumber(this.pinCount);
      this.pinCount = this.pinCount;
      this.pinCountVal = this.pinCount == 0 ? '-' : this.pinCount;
      this.threadViewData.pinCount = this.pinCountVal;
      this.threadViewData.pinStatus = this.pinStatus;
      this.pinActionText = (status == 0) ? 'Pinned' : 'Unpinned';
      this.pinModal = true;
      setTimeout(() => {
        this.pinActionText = '';
        this.pinModal = false;
      }, 1200);
      break;

      case 'plusone':
      actionFlag = (this.plusOneLoading) ? false : true;
      actionStatus = (status == 0) ? 'Yes' : 'No';
      this.plusOneStatus = (status == 0) ? 1 : 0;
      this.plusOneStatus = this.plusOneStatus;
      this.plusOneImg = (this.plusOneStatus == 1) ? 'assets/images/thread-detail/thread-plus-one-active.png' : 'assets/images/thread-detail/thread-plus-one-normal.png';
      this.plusOneCount = (status == 0) ? plusOneCount+1 : plusOneCount-1;
      this.plusOneCount = this.plusOneCount;
      this.plusOneCountVal = this.plusOneCount == 0 ? '-' : this.plusOneCount;
      this.threadViewData.plusOneCount = this.plusOneCountVal;
      break;
    }
    localStorage.setItem(pageDataInfo, JSON.stringify(this.threadViewData));
    if(actionFlag) {
      const apiFormData = new FormData();
      apiFormData.append('apiKey', Constant.ApiKey);
      apiFormData.append('domainId', this.domainId);
      apiFormData.append('countryId', this.countryId);
      apiFormData.append('userId', this.userId);
      apiFormData.append('threadId', this.threadId);
      apiFormData.append('postId', this.postId);
      apiFormData.append('ismain','1');
      apiFormData.append('status', actionStatus);
      apiFormData.append('type', type);

      this.threadPostService.addLikePinOnePlus(apiFormData).subscribe((response) => {
        localStorage.setItem("newUpdateOnThreadId",this.threadId);
        if(response.status != 'Success') {
         
          switch(type) {
            case 'like':
            this.threadViewData.likeStatus = status;
            this.threadViewData.likeStatus = this.threadViewData.likeStatus;
            this.threadViewData.likeImg = (this.threadViewData.likeStatus == 1) ? 'assets/images/thread-detail/thread-like-active.png' : 'assets/images/thread-detail/thread-like-normal.png';
            this.threadViewData.likeCount = (status == 0) ? likeCount-1 : likeCount+1;
            this.threadViewData.likeCount = this.threadViewData.likeCount;
            this.threadViewData.likeCountVal = this.threadViewData.likeCount == 0 ? '-' : this.threadViewData.likeCount;
            break;

            case 'pin':
            this.pinStatus = status;
            this.pinStatus = this.pinStatus;
            this.pinImg = (this.pinStatus == 1) ? 'assets/images/thread-detail/thread-pin-active.png' : 'assets/images/thread-detail/thread-pin-normal.png';
            this.pinCount = (status == 0) ? pinCount-1 : pinCount+1;
            this.pinCount = this.pinCount;
            this.pinCountVal = this.pinCount == 0 ? '-' : this.pinCount;
            this.threadViewData.pinCount = this.pinCountVal;
            break;

            case 'plusone':
            this.plusOneStatus = status;
            this.plusOneStatus = this.plusOneStatus;
            this.plusOneImg = (this.plusOneStatus == 1) ? 'assets/images/thread-detail/thread-plus-one-active.png' : 'assets/images/thread-detail/thread-plus-one-normal.png';
            this.plusOneCount = (status == 0) ? plusOneCount-1 : plusOneCount+1;
            this.plusOneCount = this.plusOneCount;
            this.plusOneCountVal = this.plusOneCount == 0 ? '-' : this.plusOneCount;
            this.threadViewData.plusOneCount = this.plusOneCountVal;
            break;
          }
          setTimeout(() => {
            localStorage.setItem(pageDataInfo, JSON.stringify(this.threadViewData));
          }, 50);
        }
        else{

          let apiData = new FormData();
          apiData.append('apiKey', Constant.ApiKey);
          apiData.append('domainId', this.domainId);
          apiData.append('countryId', this.countryId);
          apiData.append('userId', this.userId);
          if(this.viewVersion2){
            apiData.append('threadId', this.threadId);
            apiData.append('silentPush', '1');
            if(type == 'like'){
              apiData.append('action', 'thread-like');
            }
            if(type == 'pin'){
              apiData.append('action', 'thread-pin');
            }
            if(type == 'plusone'){
              apiData.append('action', 'thread-plusOne');
            }
            localStorage.setItem("newUpdateOnThreadId",this.threadId);
          }
          if(actionStatus == 'disliked' || actionStatus == 'dispined' || actionStatus == 'No'){}
          else{
          this.threadPostService.sendPushtoMobileAPI(apiData).subscribe((response) => { console.log(response); });
          }
          let apiDatasocial = new FormData();
          apiDatasocial.append('apiKey', Constant.ApiKey);
          apiDatasocial.append('domainId', this.domainId);
          apiDatasocial.append('threadId', this.threadId);
          apiDatasocial.append('userId', this.userId);
          apiDatasocial.append('action', type);
          apiDatasocial.append('actionType', '1');
          this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });          
        }
      });
    }
  }





  // thread like, pinned, posted user list
  threadDashboarUserList(dashboard,dashboardTab,threadId,postId,ismain){
    if(!this.msTeamAccessMobile && !this.apiUrl.threadViewPublicPage){
      if(this.domainId=='317' && this.roleId=='1')
      {
        return false;
      }
      this.bodyElem = document.getElementsByTagName('body')[0];
      this.bodyElem.classList.add('profile');
      const modalRef = this.modalService.open(FollowersFollowingComponent, {backdrop: 'static', keyboard: false, centered: true});
      modalRef.componentInstance.type = dashboard;
        let dashboardData = {
          apiKey: Constant.ApiKey,
          domainId: this.domainId,
          countryId: this.countryId,
          userId: this.userId,
          threadId: threadId,
          postId: postId,
          ismain: ismain,
          tap: dashboardTab
        };
      modalRef.componentInstance.dashboardData = dashboardData;
      modalRef.componentInstance.updatefollowingResponce.subscribe((receivedService) => {
      if (receivedService) {
        modalRef.dismiss('Cross click');
        this.bodyElem.classList.remove('profile');
      }
      });
    }
  }
/*
  URLReplacer(str){
    let match = str.match(/(?:href=")(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
    let final=str;
    if(match)
    {
      match.map(url=>{
        console.log(url)
        final=final.replace(url,"<a href=\""+url+"\" target=\"_BLANK\">"+url+"</a>")
      })
    }

    return final;
  }

  URLReplacer2(str){
    let match = str.match(/(?:href=")(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
    let final=str;
    if(match)
    {
    match.map(url=>{
      console.log(url)
      final=final.replace(url,"<a href=\""+url+"\" target=\"_BLANK\">"+url+"</a>")
    })
  }
    return final;
  }
*/
  checkNavEdit(url) {
    //let wsNav:any = localStorage.getItem('wsNav');
    //let wsNavUrl = localStorage.getItem('wsNavUrl');
    //let url = (wsNav) ? wsNavUrl : this.navUrl;
    let routeLoadIndex = pageTitle.findIndex(option => option.slug == url);
    let pageDataIndex = pageTitle.findIndex(option => option.slug == url);
    let navText = pageTitle[pageDataIndex].navEdit;
    let navFromEdit:any = localStorage.getItem(navText);
    let pageDataInfo = pageTitle[pageDataIndex].dataInfo;
    setTimeout(() => {
      localStorage.removeItem(navText);
    }, 100);
    let data = {
      navEditText: navText,
      url: url,
      navFromEdit: navFromEdit,
      routeLoadIndex: routeLoadIndex,
      dataInfo: pageDataInfo
    };
    return data;
  }
  

  // tab on user profile page
  taponprofileclick(userId){
    if(!this.apiUrl.threadViewPublicPage){
      let teamSystem=localStorage.getItem('teamSystem');
      var aurl='profile/'+userId+'';
      //let viewUrl = `threads/view/${this.threadId}`;
      let domainId = localStorage.getItem('domainId');
      let viewPath = (this.collabticDomain && this.domainId == 336) ? forumPageAccess.threadpageNewV3 : forumPageAccess.threadpageNewV2;
      let view = (this.viewVersion2) ? viewPath : forumPageAccess.threadpageNew;
      let viewUrl = `${view}${this.threadId}`;
      /* if(domainId=='165' || domainId=='1' || domainId=='63')
      {
        viewUrl = `threads/view-v2/${this.threadId}`;
      } */
      localStorage.setItem('profileNavFrom', viewUrl);
      localStorage.setItem('technicianId', this.technicianId);
      if(teamSystem){
        //window.open(aurl, IsOpenNewTab.teamOpenNewTab);
      }
      else{
        window.open(aurl, IsOpenNewTab.openNewTab);
      }
    }
  }

  changeTranslateType(ttype){
    this.threadTranslateActionEmit.emit(ttype);
  }

  updateEScalation(currentEsc){
    if(this.tvsIBDomain){
      this.remainderThread(currentEsc);
    }
  }


    // reminder Thread
    remainderThread(currentEsc){

      this.currentEscalation = this.currentEscalation;
      if(this.currentEscalation != currentEsc){
        this.nextEscalation = currentEsc;
      }

      let apiData = {
        apiKey: Constant.ApiKey,
        domainId: this.domainId,
        countryId: this.threadViewData.countries,
        userId: this.userId,
        threadId: this.threadId,
        postId: this.postId,
        postedBy: this.threadViewData.userId,
        modelName: this.threadViewData.model,
        currentEscalation: this.currentEscalation,
        nextEscalation: this.nextEscalation,
        missingEscalation: this.missingEscalationValue,
        dealerCode: this.threadViewData.dealerCode
    }

      const modalRef = this.modalService.open(AddLinkComponent, {backdrop: 'static', keyboard: false, centered: true});
      modalRef.componentInstance.reminderPOPUP = 'Escalate';
      modalRef.componentInstance.apiData = apiData;
      modalRef.componentInstance.nextEscalationText = this.nextEscalationText;
      modalRef.componentInstance.threadId = this.threadId;
      modalRef.componentInstance.resServices.subscribe((receivedService) => {
        if(receivedService){
          modalRef.dismiss('Cross click');
          console.log(receivedService);
          const msgModalRef = this.modalService.open(SuccessModalComponent, this.modalConfig);
          msgModalRef.componentInstance.successMessage = receivedService.result;
          setTimeout(() => {
            this.currentEscalation =  this.nextEscalation;
            this.nextEscalation = '';
            this.nextEscalationText = '';
            this.nextNewEscalation = '';
            this.nextNewEscalationText = '';
            this.escalationDescription = '';

            switch(this.currentEscalation){
              case 'L1':
                this.currentEscalationText = 'Escalate to L1';
                //this.nextEscalation = 'L2';
                //this.nextEscalationText = 'L2';
                break;
              case 'L2':
                this.currentEscalationText = 'Escalate to L2';
                //this.nextEscalation = 'L3';
                //this.nextEscalationText = 'L3';
                break;
              case 'L3':
                this.currentEscalationText = 'Escalate to L3';
                //this.nextEscalation = 'L4';
                //this.nextEscalationText = 'L4';
                break;
              case 'L4':
                this.currentEscalationText = 'Escalate to L4';
                //this.nextEscalation = 'L5';
                //this.nextEscalationText = 'L5';
                break;
              case 'L5':
                this.currentEscalationText = 'Escalate to L5';
                //this.nextEscalation = 'L6';
                //this.nextEscalationText = 'L6';
                //this.nextNewEscalation = 'qadl1';
                //this.nextNewEscalationText = 'QAD L1';
                break;
              case 'L6':
                this.currentEscalationText = 'Escalate to L6';
                //this.nextEscalation = 'qadl1';
                //this.nextEscalationText = 'QAD L1';
                break;
              case 'qadl1':
              case 'qadL1':
                this.currentEscalationText = 'QAD L1';
                //this.nextEscalation = 'qadl2';
                //this.nextEscalationText = 'QAD L2';
                break;
              case 'qadl2':
              case 'qadL2':
                this.currentEscalationText = 'QAD L2';
                //this.nextEscalation = 'qadl3';
                //this.nextEscalationText = 'QAD L3';
                break;
              case 'qadl3':
              case 'qadL3':
                this.currentEscalationText = 'QAD L3';
                //this.nextEscalation = '';
                //this.nextEscalationText = '';
                break;
              default:
                this.currentEscalationText = '';
                this.nextEscalation = '';
                this.nextEscalationText = '';
              break;
            }
            msgModalRef.dismiss('Cross click');

            let apiDatasocial = new FormData();
            apiDatasocial.append('apiKey', Constant.ApiKey);
            apiDatasocial.append('domainId', this.domainId);
            apiDatasocial.append('threadId', this.threadId);
            apiDatasocial.append('userId', this.userId);
            apiDatasocial.append('action', 'updateThread');
            apiDatasocial.append('platform', '3');
            apiDatasocial.append('actionType', '1');      
            this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })

          },2000);
        }
      });
    }
    getUserProfileStatus(uid) {
      const apiFormData = new FormData();
      apiFormData.append('apiKey', Constant.ApiKey);
      apiFormData.append('domainId', this.domainId);
      apiFormData.append('countryId', this.countryId);
      apiFormData.append('userId', uid);
      this.probingApi.GetUserAvailability(apiFormData).subscribe((response) => {
        let resultData = response.items;
        let availability = resultData.availability;
        let availabilityStatusName = resultData.availabilityStatusName;
        let badgeTopUser = resultData.badgeTopUser;
        this.threadViewData.availability = availability;
        this.threadViewData.availabilityStatusName = availabilityStatusName;
        this.threadViewData.profileShow = true;
      });
    }

    gotoRepairOrderPage(threadId){
      if(this.roModule || this.diagNationDomain || this.collabticAutoDomain){
        let popupro = localStorage.getItem('popupro');
        let checkNav = `ro-thread-${threadId}-new-tab-${this.threadViewData.threadId}`;
        let getNavigation = localStorage.getItem(checkNav);
        if(getNavigation && popupro == '1') {
          localStorage.removeItem(getNavigation);
          window.close();
        } else {
          let checkNav = `nro-thread-${threadId}-nav-${this.threadViewData.threadId}`;
          let getNavigation = localStorage.getItem(checkNav);
          if(getNavigation) {
            localStorage.removeItem(checkNav);
            localStorage.removeItem('backbuttontrue');
            localStorage.removeItem('backbuttonro');
            setTimeout(() => {
              this.location.back(); 
            }, 10); 
          } else {
            let navItem = `thread-ro-${this.threadViewData.threadId}-nav-${threadId}`;
            localStorage.setItem(navItem, navItem);
            this.openDetailView(threadId);
          }
          return false;
        }
        /* let backButtonFlag = localStorage.getItem('backbuttontrue') == '1' ? true : false ;
        if(backButtonFlag){   
          let backfromthread = localStorage.getItem('backfromthread'); 
          if(backfromthread == '1'){
            let prevNavURL = localStorage.getItem('prevNavURL') != undefined && localStorage.getItem('prevNavURL') != null ? localStorage.getItem('prevNavURL') : '';
            if(prevNavURL!=''){
              history.pushState(null, null, prevNavURL);
              localStorage.removeItem('backfromthread');
              localStorage.removeItem('prevNavURL');
            }
            else{
              localStorage.removeItem('backfromthread');
            }            
          }
          let backbuttonro = localStorage.getItem('backbuttonro'); 
          if(backbuttonro != null){
            history.pushState(null, null, ""+backbuttonro);
            history.pushState(null, null, ""+backbuttonro); 
            localStorage.removeItem('backbuttontrue');
            localStorage.removeItem('backbuttonro');      
            setTimeout(() => {
              this.location.back(); 
            }, 10); 
          }
          else{
            let view1 = "/threads/view-v2/";
            let aurl1 = `${view1}${this.threadViewData.threadId}`;
            localStorage.setItem('backbuttonthread', aurl1);
            localStorage.setItem('backbuttontrue', '1'); 
            let view = (this.diagNationDomain) ? forumPageAccess.repairorderPage : forumPageAccess.supportRequestPage;
            let aurl = `${view}${threadId}`;
            this.router.navigate([aurl]); 
          }
        }
        else{
          let view1 = "/threads/view-v2/";
          let aurl1 = `${view1}${this.threadViewData.threadId}`;
          localStorage.setItem('backbuttonthread', aurl1);
          localStorage.setItem('backbuttontrue', '1'); 
          let popupro = localStorage.getItem('popupro');  
          if(popupro == '1'){ } 
          else{
            localStorage.setItem('backfromthread', '1');
          }
          let view = (this.diagNationDomain) ? forumPageAccess.repairorderPage : forumPageAccess.supportRequestPage;
          let aurl = `${view}${threadId}`;
          this.router.navigate([aurl]);  
        } */        
      }
    }    

  gotoBussPage(id){
    if(this.roModule){
      let navFlag: any = 1;
      let setKey = `thread-customer-${id}`;
      localStorage.setItem(setKey, id);
      localStorage.setItem('navFromDianationThread', navFlag);
      localStorage.removeItem('customerBackAction');
      let url = `${RedirectionPage.Customers}/${id}`;
      this.router.navigate([url]);
    }
  }
    gotoRedirectPage(id){
      localStorage.setItem('selectedShopId',id);
      setTimeout(() => {
        let url = 'headquarters/all-shops/shop/'+id+'/summary';
        window.open(url,url);
      }, 1000);      
     //this.router.navigate([url]);
  }


  moreInfoNav() {
    this.moreInfo = true;
    this.detailViewCallBack.emit(this);
  }

  closeSidebar() {
    this.moreInfo = false;
  }

  getVinDetail() {
    const svcFormData = new FormData();
    svcFormData.set('apiKey', Constant.ApiKey);
    svcFormData.set('countryId', this.countryId);
    svcFormData.set('domainId', this.domainId);
    svcFormData.set('userId', this.userId);
    svcFormData.set('vin', this.threadViewData.vinNo);
    svcFormData.set('isDetail', '1')
    this.LandingpagewidgetsAPI.vehicleInfoByVIN(svcFormData).subscribe((response) => {
      let vinDetails = response.moreVinDetails;
      let validInfo = [];
      let invalidInfo = [];
      vinDetails.forEach(item => {
        if(item.value != '' && item.value != null) {
          if(item.name == 'VIN_number') {
            let replacement = 'XXXXXX';
            item.value = item.value.slice(0, -6) + replacement;
          }
          validInfo.push(item);
        } else {
          item.value = 'Unavailable';
          invalidInfo.push(item);
        }
      });
      this.vinDetails = [...validInfo, ...invalidInfo];

      if(this.apiUrl.blackTheameModule){
        setTimeout(() => {
          this.detailViewCallBack.emit(this);
        }, 50);
      }
      
    });
  }

  copyLink(){
    console.log(this.router, this.router['location']._platformLocation.location.href)
    let currUrl = this.router['location']._platformLocation.location.href;
   
    let urlSplit = currUrl.split('/');
    let checkParam = 'search-page';
    let searchFlag = urlSplit.includes(checkParam);
    let checkParamfixes = 'fixes-landing';
    let checkParamfixesFlag = urlSplit.includes(checkParamfixes);
    let lastIndex = parseInt(currUrl.lastIndexOf("/"));
    let copyUrl = currUrl.slice(0,lastIndex+1);
    if(searchFlag) {
      let navParam = 'threads/view-v3/'
      copyUrl = `${copyUrl}${navParam}${this.threadId}`;
    }
    else if(checkParamfixesFlag) {
      //let navParam = 'threads/view-v3/';
      let navParam = 'fixes-landing/cluster/view/';
      copyUrl=copyUrl.replace("/"+checkParamfixes,"");
      copyUrl=copyUrl.replace("cluster/view/","");
      copyUrl = `${copyUrl}${navParam}${this.threadId}`;
    }
     else {
      copyUrl = `${copyUrl}${this.threadId}`;
    }    
    console.log(copyUrl)
    navigator.clipboard.writeText(copyUrl);
    this.copiedModal = true;
    setTimeout(() => {
      this.copiedModal = false;
    }, 1200);
  }

  publicCopyLink(){
    if(this.tvsDomain){
      let currentURL11 = window.location.href;
      let currentURL21 = this.router.url;
      let currentURL31 = currentURL11.replace(currentURL21,"");
      let copyUrl = currentURL31+"/threads/view-v2/"+this.threadId;
      console.log(copyUrl);
      copyUrl = `${copyUrl}`;
      navigator.clipboard.writeText(copyUrl);
      this.copiedModalPublic = true;
      setTimeout(() => {
        this.copiedModalPublic = false;
      }, 1500);
    }
    else{
      let currentURL11 = window.location.href;
      let currentURL21 = this.router.url;
      let currentURL31 = currentURL11.replace(currentURL21,"");
      let inId = this.industryType.id;
      let wsid = "1";
      let platformId = localStorage.getItem('platformId');

      let param1 = btoa(this.threadId);
      let param2 = btoa(this.postId);
      let param3 = btoa(this.domainId);
      let param4 = btoa(this.userId);
      let param5 = btoa(wsid);
      let param6 = btoa(inId);
      let param7 = btoa(platformId);
      
      console.log(param1,param2,param3,param4,param5,param6,param7);
      let copyUrl = currentURL31+"/auth/thread-view?param1="+param1+"&param2="+param2+"&param3="+param3+"&param4="+param4+"&param5="+param5+"&param6="+param6+"&param7="+param7;

      console.log(copyUrl);
      copyUrl = `${copyUrl}`;
      navigator.clipboard.writeText(copyUrl);
      this.copiedModalPublic = true;
      setTimeout(() => {
        this.copiedModalPublic = false;
      }, 1500);
    }
  }

  dtcFilter(item) {    
    if(this.apiUrl.blackTheameModule){}
    else{
      console.log(item, this.threadViewData)
      let fixFilterItems = [{'query': item, 'make': this.threadViewData.make, 'model': this.threadViewData.model, 'year': this.threadViewData.year }];
      this.fixesFilter = true;
      localStorage.setItem('fixesFilterItems', JSON.stringify(fixFilterItems));
      this.detailViewCallBack.emit(this);
    }
  }

    getROInfo() {
    let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('id', this.WorkOrder);
    this.repairOrderApi.getWorkOrderList(formData).subscribe(response => {
      console.log(response)
      let responseData = response.data;
      let item = responseData.items[0];
      let total = responseData.total;
      if(total > 0) {
        let threadId = item.thread_id;
        this.roLinkFlag = (this.threadId == threadId) ? true : false;
      }
    });
  }

  nhtsaRecall() {
    let make = this.threadViewData.make;
    let model = this.threadViewData.model;
    let year = this.threadViewData.year;
    const recallFormData = new FormData();
    recallFormData.set('apikey', Constant.ApiKey);
    recallFormData.set('domainId', this.domainId);
    recallFormData.set('userId', this.userId);
    recallFormData.set('make', make);
    recallFormData.set('model', model);
    recallFormData.set('year', year);
    this.LandingpagewidgetsAPI.getRecallData(recallFormData).subscribe((response) => {
      console.log(response)
      let recallResponse = response.data;
      //console.log(recallResponse.Count, recallResponse.results)      
      if(recallResponse != null){
        this.recallEmpty = false;
        this.recallItemEmpty = (recallResponse.Count == 0) ? true : false;
        this.recallItems = recallResponse.results;
      }
      else{
        this.recallItemEmpty = true;
        this.recallEmpty = true;
        this.recallItems = [];
      }
      if(this.apiUrl.blackTheameModule){
        setTimeout(() => {
          this.detailViewCallBack.emit(this);
        }, 50);
      }
    });
  }

  viewNhtsaRecall() {
    this.recallFlag = true;
  }

  closeDialog() {
    this.recallFlag = false;
    this.recallEmpty = false;
    this.recallItems = [];    
  }

  // Accordion Open
  onTabOpen() {
    setTimeout(() => {
      this.directiveRef.update();
    }, 100);
  }

  // Accordion Close
  onTabClose() {
    setTimeout(() => {
      this.directiveRef.update();
    }, 100);
  }

  goToAccountSubscription() {
    this.router.navigateByUrl('account-subscription');
  }

  changeSummary(){
    this.resolutionDefaultFlag = (this.resolutionDefaultFlag) ? false : true; 
    if(!this.resolutionDefaultFlag){  
      this.getSolrSummary(this.threadId);
    }
  }

  getSolrSummary(id) {
    if(this.llmSummary == ''){
      this.llmSummaryLoading = true;    
      var objData = {};  
      objData["type"] = '1';
      objData["threadId"] = id;
      objData["domainId"]=this.domainId;
      this.commonApi.getSolrSearchSummary(objData).subscribe(response => {
        if(response=='null' || response==null)
        {
         
          this.llmSummary='';
          if(this.apiUrl.blackTheameModule){
            this.apiUrl.llmSummary = this.llmSummary;
          }          
          this.llmSummaryLoading = false;
          return false;

        }
      
        let msg = response.message;
        if(msg && msg != ''){
          //msg=this.authenticationService.convertunicode(this.authenticationService.ChatUCode(msg));
          //this.threadViewData.content = this.sanitizer.bypassSecurityTrustHtml(msg);  
          this.llmSummary = msg;
          if(this.apiUrl.blackTheameModule){
            this.apiUrl.llmSummary = this.llmSummary;
          }
          if(this.llmSummary != ''){
            this.llmSummary = this.llmSummary.replace("<p>Issues:</p>", "<p class='summary-highlight-color'>Issues:</p>");
            this.llmSummary = this.llmSummary.replace("<p>Resolutions:</p>", "<p class='summary-highlight-color'>Resolutions:</p>");
          }          
          this.summaryUpdateAPI();
         
        }
      });
    }
  }


  summaryUpdateAPI(){
    let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('threadId', this.threadId);
    formData.append('threadUpdatedDesc', this.llmSummary);
    this.threadPostService.updateLLM(formData).subscribe(response => {
      
      this.llmSummary=response.itemContent;
      this.llmSummaryLoading = false;
      let apiDatasocial = new FormData();
      apiDatasocial.append('apiKey', Constant.ApiKey);
      apiDatasocial.append('domainId', this.domainId);
      apiDatasocial.append('threadId', this.threadId);
      apiDatasocial.append('userId', this.userId);
      apiDatasocial.append('action', 'updateThread');
      apiDatasocial.append('platform', '3');
      apiDatasocial.append('actionType', '1');

      this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })

    }); 
  }

  aisummaryUpdateAPI(){
    let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('threadId', this.threadId);
    formData.append('threadUpdatedDesc', this.AISummary);
    this.threadPostService.updateAI(formData).subscribe(response => {
      
      //this.llmSummary=response.itemContent;
      //this.llmSummaryLoading = false;
      let apiDatasocial = new FormData();
      apiDatasocial.append('apiKey', Constant.ApiKey);
      apiDatasocial.append('domainId', this.domainId);
      apiDatasocial.append('threadId', this.threadId);
      apiDatasocial.append('userId', this.userId);
      apiDatasocial.append('action', 'updateThread');
      //apiDatasocial.append('action', 'aisummaryupdate');
      //apiDatasocial.append('summaryText', this.AISummary);
      apiDatasocial.append('platform', '3');
      apiDatasocial.append('actionType', '1');

      this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { })

    }); 
  }


  openDetailView(id) {
    this.bodyElem = document.getElementsByTagName('body')[0];
    if(!document.body.classList.contains("view-modal-popup")) {
      this.bodyElem.classList.add("view-modal-popup");
      this.bodyElem.classList.add("view-modal-popup-thread");
    }
    if(!document.body.classList.contains("repairorder")) {
      this.bodyElem.classList.add("repairorder");
    }
    const modalRef = this.modalService.open(ViewRoDetailComponent, {backdrop: 'static', keyboard: true, centered: true, size: 'max-width-ro'});
    modalRef.componentInstance.repairOrderId = id;
    modalRef.componentInstance.KAServices.subscribe((receivedService) => {
      console.log(receivedService);
      modalRef.dismiss('Cross click');
    });
  }

  openRepairOrderPOPUP(type,id){
    this.bodyElem = document.getElementsByTagName('body')[0];   
    if(!document.body.classList.contains('view-modal-popup')) {
      document.body.classList.add('view-modal-popup');
    }
    if(!document.body.classList.contains('view-modal-popup-manage')) {
      document.body.classList.add('view-modal-popup-manage');
    }
    if(!document.body.classList.contains("landing-page")) {
      document.body.classList.add("landing-page");
    }
    
    const modalRef = this.modalService.open(RepairOrderManageComponent, {backdrop: 'static', keyboard: false, centered: true, size: 'max-width-ro'});
    modalRef.componentInstance.workOrderPage = 'view-page';
    modalRef.componentInstance.workOrderType = type;
    modalRef.componentInstance.workOrderId = id;
    modalRef.componentInstance.ROManageService.subscribe((receivedService) => {
      console.log(receivedService)
      let action = receivedService['action'];
      let closeFlag = (action == 'update' || action == 'close') ? true : false;
      if(action == 'update'){  
                
      }
      if(closeFlag) {
        document.body.classList.remove("landing-page");    
        document.body.classList.remove("view-modal-popup");    
        document.body.classList.remove('view-modal-popup-manage'); 
        modalRef.dismiss('Cross click');
      }
    });  
  }

  getReasonHistory(){      
    this.reasonFeedbackHistoryLoading = true;
    this.reasonFeedbackHistoryArr = [];
    let apiDataReason = new FormData();
    apiDataReason.append('apiKey', Constant.ApiKey);
    apiDataReason.append('domainId', this.domainId);
    apiDataReason.append('userId', this.userId);
    apiDataReason.append('threadId', this.threadId);
    //apiDataReason.append('postId', this.postId);
  
    this.threadPostService.techsupportreasondata(apiDataReason).subscribe(res => { 
      this.reasonFeedbackHistoryLoading = false;         
      if(res.status=='Success'){        
        let items = res.items[0]; 
        if(res.items && res.items.length>0 ){
        this.apiUrl.reason = true;
        let createdOnNew = items.createdOn;
        let reasonType = items.reasonType;
        let postDelayReasons=localStorage.getItem('postDelayReasons');
        if(postDelayReasons)
        {
          let postDelayReasonsArr=JSON.parse(postDelayReasons);
          if(postDelayReasonsArr && postDelayReasonsArr.length>0){
            postDelayReasonsArr.forEach(item => {
              console.log(item.id);
              console.log(item);
              if(item.id == reasonType){
                items.reasonTypeName = item.name;
                }
              });
          }
        }
        let createdOnDate = moment.utc(createdOnNew).toDate();
        let createdOnDateFormate = moment(createdOnDate).local().format('MMM DD, YYYY . h:mm A');
        items.createdOnDateFormate = createdOnDateFormate;        
        this.reasonFeedbackHistoryArr.push(items);
      }
      }
    }); 
  }

  showRecentHistory(){
    this.reasonFeedbackHistory = true;
    if(this.reasonFeedbackHistoryArr && this.reasonFeedbackHistoryArr.length > 0){ }
    else{
      this.getReasonHistory();
    }
  }

  getAISummary() {
    if(this.AISummary == ''){
      this.AISummaryLoading = true;    
      var objData = {};  
      objData["type"] = '1';
      objData["threadId"] = this.threadId;
      objData["domainId"]=this.domainId;
      this.commonApi.getSolrAISummary(objData).subscribe(response => {
        this.AISummaryLoading = false;
        if(response=='null' || response==null)
        {        
          this.AISummary='';
        }
        else{
          let msg = response.message;
          if(msg && msg != ''){
             //this.AISummary=msg;  
           let AIsummaryText=msg;

           this.AISummary = AIsummaryText.replaceAll('\n','</br>');
            /*for(let er=0;er<split.length;er++)
            {
              this.AISummary += split[er]+'</br>';
            }*/  
            this.aisummaryUpdateAPI();          
          }
        }  
      });  
    }  
    else{
      this.AISummaryLoading = false;
      this.AISummary = this.AISummary.replaceAll('\n','</br>');
    }
    
  }

  summaryClick(type){  
    this.AISummaryAction = type;
    this.AISummaryShow =  type == 'summary-show' ? true : false;
    if(this.AISummaryShow){
      this.getAISummary();
    }
    setTimeout(() => {
      this.detailViewCallBack.emit(this);
    }, 150);

  }

  checkTitleParam(){
    //if(this.roModule) {      
      setTimeout(() => {
        let getParams:any = localStorage.getItem('param');
        getParams = (getParams && getParams != 'undefined') ? JSON.parse(getParams) : '';
        if(getParams != '') {
          let contItems = getParams.items;
          let cindex = contItems.findIndex(option => option.contentTypeId == this.contentType);
          if(cindex >= 0) {
            this.title = contItems[cindex].name;
            this.shortTitle = this.title.split(' ').map(x => x[0]).join('');
          }
        }
        else{
          setTimeout(() => {
            this.checkTitleParam();
          }, 1000); 
        }        
      }, 1000); 
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    localStorage.removeItem('highlightSearchStr');
  }
}
